import { useTranslation } from "react-i18next";
import i18n, { getLocale, translate as tr } from "../../i18n";
import React, { lazy, Suspense } from 'react';
import "../../utils/chartjs";
import { Bar } from "react-chartjs-2";
import Sidebar from "../common/sidebar";
//import { TimerList } from "../Dashboard/TimerList";
import axios from "axios";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import ManualPlayButton from "../common/svgs/ManualPlayButton";
import ArrowButton from "../common/svgs/ArrowButton";
//import moment from "moment/moment.js";
import Calendar from "../common/CalendarPicker";
import moment from 'moment-timezone';
import DeleteButton from "../common/svgs/delete_button";
import Loader from "../common/loader";
import TimerListSkeleton from "../Dashboard/TimerListSkeleton";
import DashboardSkeleton from "../Dashboard/DashboardSkeleton";
import "../../assets/css/calendar_in_dashboard.css";
import "../../assets/css/dashboard.css";
import ProjectChart from "../Dashboard/ProjectChart";
import HeatWidget from "../Dashboard/HeatWidget";
import Spinner from 'react-bootstrap/Spinner';
import ProjectModal from "../Projects/projectModal";
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import {alterDisplayTime,alterTimeFormat} from "../common/displayTime.js";
import Footer from '../common/footer';
import CheckInWidget from '../Attendance/CheckInWidget';
import OnboardingChecklist from '../common/OnboardingChecklist';
import ScrollToTopButton from '../common/ScrollToTopButton';

const TimerList = lazy(() => import("../Dashboard/TimerList"));
const tagStyleDisplay = {
  position: "absolute",
  transform: "translate3d(20px, -44px, 0px)",
  top: "90px",
  left: "0px",
  willChange: "transform",
  display: "block",
  minWidth: "18em", 
};

class Home extends React.Component {
  handleLanguageChange = () => this.forceUpdate();

  
  constructor(props) {    
    super();
    this.state = {
      timerStart: 0,
      timerTime: 0,
      timer_start  : 0,
      timer_end : 0,
      timerNow: Date.now(),
      project: "",
      project_id: "",
      asanaTasks: [],
      asanaState: null,
      asana_task_id: "",
      asanaError: "",
      asanaSuggestOpen: false,
      asanaActive: -1,
      client: "",
      client_id: "",
      title: "",
      isStop: 1,
      is_billable: 0,
      tagterm : "",
      tagArray: [],
      tag_check_array: [],
      tagOpen: false,
      timer_id: "",
      projectArray: [],
      projectCatalog: {},
      clientArray: [],
      timeList: [],
      timeList2 : [],
      heatmapEntries: [],
      projectOpen: false,
      searchTerm: "",
      workspaceArray: [],
      workspace_id: 0,
      workspace_title: "",
      isManual: false,
      manualDate  :new Date(),
      displayCalendar : false,
      manualStartTime : moment().format("hh:mm A"),
      manualEndTime : moment().format("hh:mm A"),
      isManuallyChanged : false,
      displayRunningTimerCalendar : false,
      runningTimerStart : "",
      runningTimerStop : moment().format("hh:mm A"),
      runningDuration : "",
      durationFieldError : false,
      durationFlash : false,
      titleError : false,
      autofilled         : false,
      autofilledProject  : false,
      projectAutoMatched : false,
      projectSelectionSource : "",
      autofilledTags     : false,
      autofilledBillable : false,
      offset : 0,
      loading : true,
      spinner : false,
      projectModalShow : false,
      requiredFields : false,
      timeFormat : "",
      timeDurationFormat : "",
      timezone : "",
      dbLockedDate : "",
      isTimeEntryLocked : false,
      is_group_similar : false,
      chartData7d      : [],
      // ── Idle detection ──────────────────────────────────
      idleModalShow    : false,
      idleMinutes      : 0,
      // ── Daily goal ───────────────────────────────────────
      dailyGoalHours   : 8,
      dailyGoalEditing : false,
      dailyGoalInput   : "8",
      showAllProjects  : false,
      suggestions: [],
      suggestionsLoading: true,
      suggestionCursor: 0,
      suggestionActionId: null,
      suggestionMessage: "",
      suggestionMessageType: "",
      timerSyncMessage: "",
      timerSyncMessageType: "success",
      selectedRecentDateKey: null,
      selectedRecentDateList: null,
      // ── Check-in enforcement ─────────────────────────────
      checkinPromptShow:    false,
      checkinPromptLoading: false,
      requireCheckInOut:    false,
      isCheckedIn:          false,
    };

    this.wrapperRef = React.createRef();
    this.calendarRef = React.createRef();
    this.runningCalendarRef = React.createRef();
    this.inputRef = React.createRef();
    this.tagDropdownRef = React.createRef();
    this.recentEntriesRef = React.createRef();
    this.timerSyncToastTimer = null;
    this.suppressTimerSyncUntil = 0;
    this.pendingExtensionLaunch = null;
    this.extensionLaunchInProgress = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.auth.workspace_id !== this.props.auth.workspace_id) {
      this.setState({
        loading: true,
        timeList: [],
        timeList2: [],
        heatmapEntries: [],
        chartData7d: [],
        offset: 0,
        suggestions: [],
        suggestionsLoading: true,
        projectCatalog: {},
        searchTerm: "",
        selectedRecentDateKey: null,
        selectedRecentDateList: null,
      }, () => {
        this.startPage();
      });
    }

    if (
      this.pendingExtensionLaunch &&
      !this.extensionLaunchInProgress &&
      ((!prevProps.auth.isAuthenticated && this.props.auth.isAuthenticated) ||
        prevState.loading !== this.state.loading ||
        prevState.isStop !== this.state.isStop ||
        prevProps.auth.workspace_id !== this.props.auth.workspace_id)
    ) {
      this.tryLaunchPendingExtensionTimer();
    }

    if (prevState.project_id !== this.state.project_id || prevState.timer_id !== this.state.timer_id) {
      this.syncAsanaTasks(prevState);
    }
  }

  asanaWorkspace = () => this.state.workspace_id || this.props.auth.workspace_id;

  asanaConfig = () => ({ headers: { Authorization: `Bearer ${this.props.auth.token}`, "Content-Type": "application/json" } });

  linkAsanaTask = (timer_id, task_id) =>
    axios.post("/api/integrations/asana/link-timer", { workspace_id: this.asanaWorkspace(), timer_id, task_id: task_id || null }, this.asanaConfig());

  // Projects imported from Asana offer their open tasks (read with the user's own Asana connection).
  // this.asanaSource: entry restarted/prefilled from the recent list – its Asana task is carried over.
  // this.asanaAwaitingTimer: a restart has set isStop=0 but the new timer_id is not known yet.
  syncAsanaTasks = async (prevState) => {
    const { project_id, timer_id, isStop, asana_task_id } = this.state;
    if (prevState.timer_id !== timer_id) this.asanaAwaitingTimer = false;
    const running = isStop === 0 && !!timer_id && !this.asanaAwaitingTimer;
    const projectChanged = prevState.project_id !== project_id;
    const source = this.asanaSource;
    const request = (this.asanaRequest || 0) + 1;
    this.asanaRequest = request;
    const tasksFor = (lookupTimer) => axios.get("/api/integrations/asana/project-tasks", {
      ...this.asanaConfig(),
      params: { workspace_id: this.asanaWorkspace(), project_id, ...(lookupTimer ? { timer_id: lookupTimer } : {}) },
    }).then(res => res.data || {});
    try {
      if (projectChanged && running && prevState.timer_id === timer_id && prevState.asana_task_id) {
        await this.linkAsanaTask(timer_id, null);
      }
      if (!projectChanged && running && asana_task_id) {
        await this.linkAsanaTask(timer_id, asana_task_id);
      }
      if (!project_id) {
        this.asanaSource = null;
        this.setState({ asanaTasks: [], asanaState: null, asana_task_id: "", asanaError: "" });
        return;
      }
      const data = await tasksFor(running ? timer_id : source);
      if (this.asanaRequest !== request) return;
      let taskId = running || source ? (data.task_id || "") : (projectChanged ? "" : this.state.asana_task_id);
      if (running && !taskId && source && data.connected) {
        const sourceTask = (await tasksFor(source)).task_id;
        if (sourceTask) { await this.linkAsanaTask(timer_id, sourceTask); taskId = sourceTask; }
      }
      if (this.asanaRequest !== request) return;
      if (source === this.asanaSource) this.asanaSource = null;
      this.setState({
        asanaTasks: data.results || [],
        asanaState: data.linked ? (data.connected ? "connected" : "disconnected") : null,
        asana_task_id: taskId,
        asanaError: "",
      });
    } catch (err) {
      if (this.asanaRequest !== request) return;
      this.setState({ asanaTasks: [], asanaState: null, asana_task_id: "", asanaError: err.response?.data?.msg || "" });
    }
  };

  // Restart / prefill from the recent entries: keep the Asana task of the source entry.
  carryAsanaTask = (item, awaitingTimer) => {
    this.asanaSource = item && item.timer_id ? item.timer_id : null;
    this.asanaAwaitingTimer = !!awaitingTimer;
  };

  selectAsanaTask = async (task_id) => {
    const previous = this.state.asana_task_id;
    const running = this.state.isStop === 0 && !!this.state.timer_id;
    const task = this.state.asanaTasks.find(t => t.gid === task_id);
    this.setState({
      asana_task_id: task_id,
      asanaError: "",
      asanaSuggestOpen: false,
      asanaActive: -1,
      ...(task ? { title: task.name, titleError: false } : {}),
    });
    if (!running) return;
    try {
      await this.linkAsanaTask(this.state.timer_id, task_id);
      if (task) this.changeTitle(this.state.timer_id, task.name);
    } catch (err) {
      this.setState({ asana_task_id: previous, asanaError: err.response?.data?.msg || tr("The Asana task could not be linked.") });
    }
  };

  // Asana tasks of the selected project, shown as suggestions under the description input.
  asanaSuggestions = () => {
    const { asanaState, asanaTasks, asana_task_id, title } = this.state;
    if (asanaState !== "connected") return [];
    const term = (title || "").trim().toLowerCase();
    const selected = asanaTasks.find(t => t.gid === asana_task_id);
    if (!term || (selected && selected.name.toLowerCase() === term)) return asanaTasks.slice(0, 8);
    return asanaTasks.filter(t => t.name.toLowerCase().includes(term)).slice(0, 8);
  };

  asanaSuggestKeydown = (e) => {
    if (!this.state.asanaSuggestOpen) return false;
    const list = this.asanaSuggestions();
    if (e.key === "Escape") { this.setState({ asanaSuggestOpen: false }); return true; }
    if (!list.length) return false;
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      const step = e.key === "ArrowDown" ? 1 : -1;
      this.setState({ asanaActive: (this.state.asanaActive + step + list.length) % list.length });
      return true;
    }
    if (e.key === "Enter" && this.state.asanaActive >= 0) {
      e.preventDefault();
      this.selectAsanaTask(list[this.state.asanaActive].gid);
      return true;
    }
    return false;
  };

  renderAsanaSuggestions = () => {
    const { asanaSuggestOpen, asanaState, asanaError, asanaActive, asana_task_id } = this.state;
    if (!asanaSuggestOpen && !asanaError) return null;
    const list = this.asanaSuggestions();
    if (!asanaError && asanaState !== "disconnected" && !list.length) return null;
    let lastGroup = null;
    return (
      <div className='asana-suggest' role='listbox' onMouseDown={(e) => e.preventDefault()}>
        {asanaError && <div className='asana-suggest-error' role='alert'>{asanaError}</div>}
        {asanaSuggestOpen && asanaState === "disconnected" && (
          <a className='asana-suggest-connect' href='/integrations'>{tr("Connect Asana to pick tasks of this project")}</a>
        )}
        {asanaSuggestOpen && list.map((t, i) => {
          const group = t.mine ? tr("Assigned to me") : tr("Other tasks");
          const header = group !== lastGroup ? <div className='asana-suggest-group'>{group}</div> : null;
          lastGroup = group;
          return (
            <React.Fragment key={t.gid}>
              {header}
              <div
                role='option'
                aria-selected={t.gid === asana_task_id}
                className={`asana-suggest-item${i === asanaActive ? ' asana-suggest-item--active' : ''}${t.gid === asana_task_id ? ' asana-suggest-item--selected' : ''}`}
                onMouseEnter={() => this.setState({ asanaActive: i })}
                onClick={() => this.selectAsanaTask(t.gid)}
              >
                {t.name}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  componentDidMount = () => {
    i18n.on("languageChanged", this.handleLanguageChange);
    this.pendingExtensionLaunch = this.readExtensionTimerLaunch();
    let timeZone = "";
    if(this.props.auth.user_properties !== null &&
      this.props.auth.user_properties !== undefined && 
      this.props.auth.user_properties !== "" ) {
        timeZone = this.props.auth.user_properties.timeZone;
        if(timeZone === "" || timeZone === null || timeZone === undefined) {
          moment.tz.setDefault();
          let m1 = moment();
          let dd = m1.date();
          let MM = m1.month();
          let yy = m1.year();
    
          let m = moment({ year :yy, month :MM, day :dd})._d;
          this.setState({
            timeFormat : alterTimeFormat(this.props.auth.user_properties.timeFormat),
            timeDurationFormat : this.props.auth.user_properties.timeDurationFormat.split(' ')[0],
            manualDate : m,
            timezone : moment.tz.guess()
          })
        }
        else {
          timeZone = timeZone.split(' ')[0];
          moment.tz.setDefault(timeZone)
          let m1 = moment();
          let dd = m1.date();
          let MM = m1.month();
          let yy = m1.year();
    
          let m = moment({ year :yy, month :MM, day :dd})._d;
          this.setState({
            timeFormat : alterTimeFormat(this.props.auth.user_properties.timeFormat),
            timeDurationFormat : this.props.auth.user_properties.timeDurationFormat.split(' ')[0],
            manualDate : m,
            timezone : this.props.auth.user_properties.timeZone.split(' ')[0]
          })
        }
      }
      else {
        moment.tz.setDefault();
        let m1 = moment();
        let dd = m1.date();
        let MM = m1.month();
        let yy = m1.year();
  
        let m = moment({ year :yy, month :MM, day :dd})._d;
        this.setState({
          timeFormat : "DD-MM-YYYY",
          timeDurationFormat : "Improved",
          manualDate : m,
          timezone : moment.tz.guess()
        })
      } 

    //console.log(moment().format("DD-MM-YYYY hh:mm:ss A"))
    this.runTimer();
    document.addEventListener(
      "click",
      (e) => {
        if (this.tagDropdownRef.current && this.tagDropdownRef.current.contains(e.target)) {
          return;
        }
        this.hideTagDropDown();
      },
      true
    );
    document.addEventListener("mousedown", this.handleClickOutside);
    this.startPage();
    this.fetchCheckinStatus();
    this.clientList();
    this.handleTimerSyncEvent = (event) => {
      if (Date.now() < this.suppressTimerSyncUntil) {
        return;
      }
      const action = event?.detail?.action || 'updated';
      const label =
        action === 'started'
          ? tr("Timer started on another device")
          : action === 'stopped'
          ? tr("Timer stopped on another device")
          : action === 'deleted'
          ? tr("Timer removed on another device")
          : tr("Timer updated on another device");

      this.setState({ timerSyncMessage: `${label}. Syncing now...`, timerSyncMessageType: 'success' });
      if (this.state.idleModalShow) {
        this.setState({ idleModalShow: false, idleMinutes: 0 });
      }
      this.lastActivity = Date.now();
      if (this.timerSyncToastTimer) clearTimeout(this.timerSyncToastTimer);
      this.timerSyncToastTimer = setTimeout(() => {
        this.setState({ timerSyncMessage: "", timerSyncMessageType: "success" });
      }, 2500);

      this.startPage(true);
    };
    window.addEventListener("minutezilla:timer-changed", this.handleTimerSyncEvent);
    this.handleDesktopIdleResponse = (event) => {
      const action = event?.detail?.action || 'kept';
      this.lastActivity = Date.now();
      this.setState({ idleModalShow: false, idleMinutes: 0 });
      if (action === 'discarded') {
        this.startPage(true);
      }
    };
    window.addEventListener("minutezilla:desktop-idle-response", this.handleDesktopIdleResponse);
    this.handleDesktopActivity = () => {
      this.lastActivity = Date.now();
      if (this.state.idleModalShow) {
        this.setState({ idleModalShow: false, idleMinutes: 0 });
      }
    };
    window.addEventListener("minutezilla:desktop-activity", this.handleDesktopActivity);
    this.handleAttendanceChanged = () => { this.fetchCheckinStatus(); };
    window.addEventListener("minutezilla:attendance-changed", this.handleAttendanceChanged);
    this.liveClock = setInterval(() => {
      this.setState({ timerNow: Date.now() });
    }, 1000);
    this.recentEntriesSyncTimer = setInterval(() => {
      if (this.props.auth?.token && this.props.auth?.workspace_id) {
        this.startPage(true);
      }
    }, 15 * 1000);

    // ── Daily goal: load from localStorage ──────────────
    const savedGoal = parseFloat(localStorage.getItem("minutezilla_daily_goal_hours"));
    if (savedGoal && savedGoal > 0) {
      this.setState({ dailyGoalHours: savedGoal, dailyGoalInput: String(savedGoal) });
    }

    // ── Idle detection: track last activity ─────────────
    this.lastActivity = Date.now();
    this.IDLE_THRESHOLD_MS = 10 * 60 * 1000; // 10 minutes
    ["mousemove", "keydown", "mousedown", "touchstart", "scroll"].forEach(evt =>
      document.addEventListener(evt, this.handleActivity, { passive: true })
    );

    // ── Desktop activity: suppress idle when desktop app is tracking ─────────
    // The desktop app pushes a heartbeat every 60s. When active_seconds > 0
    // the backend emits 'desktop:activity' via Socket.IO. Treating that as
    // user input prevents false idle prompts while the user works in another
    // window with the desktop app open.
    // ── Keyboard shortcut: Ctrl+Space ───────────────────
    document.addEventListener("keydown", this.handleKeyboardShortcut);
    this.tryLaunchPendingExtensionTimer();
  };

  componentWillUnmount() {
    i18n.off("languageChanged", this.handleLanguageChange);
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleKeyboardShortcut);
    if (this.handleTimerSyncEvent) {
      window.removeEventListener("minutezilla:timer-changed", this.handleTimerSyncEvent);
    }
    if (this.handleDesktopIdleResponse) {
      window.removeEventListener("minutezilla:desktop-idle-response", this.handleDesktopIdleResponse);
    }
    if (this.handleDesktopActivity) {
      window.removeEventListener("minutezilla:desktop-activity", this.handleDesktopActivity);
    }
    if (this.handleAttendanceChanged) {
      window.removeEventListener("minutezilla:attendance-changed", this.handleAttendanceChanged);
    }
    if (this.timerSyncToastTimer) {
      clearTimeout(this.timerSyncToastTimer);
    }
    clearInterval(this.liveClock);
    clearInterval(this.timer);
    clearInterval(this.timer2);
    clearInterval(this.backgroundTimer);
    if (this.recentEntriesSyncTimer) {
      clearInterval(this.recentEntriesSyncTimer);
    }
    ["mousemove", "keydown", "mousedown", "touchstart", "scroll"].forEach(evt =>
      document.removeEventListener(evt, this.handleActivity)
    );
    document.title = "Minutezilla";
  }

  // ── Idle detection ─────────────────────────────────────────────────────────
  handleActivity = () => {
    const now = Date.now();
    const elapsed = now - (this.lastActivity || now);
    // If timer is running and user was idle beyond threshold, prompt
    if (this.state.isStop === 0 && elapsed > this.IDLE_THRESHOLD_MS && !this.state.idleModalShow) {
      const idleMinutes = Math.round(elapsed / 60000);
      this.setState({ idleModalShow: true, idleMinutes });
    }
    this.lastActivity = now;
  }

  discardIdleTime = () => {
    const idleMs = this.state.idleMinutes * 60 * 1000;
    // Shift timerStart forward so elapsed time excludes idle period
    const newTimerStart = parseInt(this.state.timerStart) + idleMs;
    const newTimerStartUnix = parseInt(this.state.timer_start) + Math.round(idleMs / 1000);
    this.setState({
      timerStart   : newTimerStart,
      timer_start  : newTimerStartUnix,
      idleModalShow: false,
      idleMinutes  : 0,
    });
  }

  keepIdleTime = () => {
    this.setState({ idleModalShow: false, idleMinutes: 0 });
  }

  // ── Keyboard shortcut ───────────────────────────────────────────────────────
  handleKeyboardShortcut = (e) => {
    if (e.key === "Escape" && this.state.projectOpen) {
      e.preventDefault();
      this.setState({ projectOpen: false, showAllProjects: false });
      return;
    }

    // Don't fire when user is typing in any input/textarea/contenteditable
    const tag = document.activeElement && document.activeElement.tagName.toLowerCase();
    if (tag === "input" || tag === "textarea" || tag === "select") return;
    if (e.ctrlKey && e.code === "Space") {
      e.preventDefault();
      if (this.state.isStop === 1) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    }
  }

  // ── Daily goal ──────────────────────────────────────────────────────────────
  saveDailyGoal = () => {
    const val = parseFloat(this.state.dailyGoalInput);
    const hours = (!isNaN(val) && val > 0) ? val : 8;
    localStorage.setItem("minutezilla_daily_goal_hours", String(hours));
    this.setState({ dailyGoalHours: hours, dailyGoalInput: String(hours), dailyGoalEditing: false });
  }

  handleClickOutside = (event) => {
    const wrapper = this.wrapperRef?.current;
    const calendar = this.calendarRef?.current;
    const runningCalendar = this.runningCalendarRef?.current;
    const timerEditArea = this.inputRef?.current?.parentElement;

    if (wrapper && !wrapper.contains(event.target)) {
      this.setState({ projectOpen: false, showAllProjects: false });
    }
    if (calendar && !calendar.contains(event.target)) {
      this.setState({displayCalendar : false})
    }
    if (
      runningCalendar &&
      !runningCalendar.contains(event.target) &&
      !(timerEditArea && timerEditArea.contains(event.target))
    ) {
      this.setState({displayRunningTimerCalendar:false, durationFieldError : false})
    }
  };

  runTimer = () => {
    let format = this.props.auth.user_properties !== null &&
    this.props.auth.user_properties !== undefined? 
    alterTimeFormat(this.props.auth.user_properties.timeFormat):"hh:mm A";
    if(this.state.isManuallyChanged === false)  {
      this.backgroundTimer = setInterval(() => {
      this.setState({
        manualStartTime : moment().format(format),
        manualEndTime : moment().format(format),//"hh:mm A"),
        runningTimerStop : moment().format(format)
      });
      if(this.state.isStop === 1) {
        this.setState({runningTimerStart : moment().format(format)})
      }
    }, 10 * 1000);
  }
  else {
    clearInterval(this.backgroundTimer);
  }
  }

  groupByEntry = async (results,group_similar) => {
    results = results.slice().sort((a, b) => new Date(b.crdate) - new Date(a.crdate));
    if(group_similar === true) {
      let newArray = [];
      let totalLength = results.length;
      let uniq = [];
      await results.map((item, i) => {
          newArray = [...newArray,moment(item.timer_start,"X").format("ddd MMM DD YYYY")]
          if(totalLength === newArray.length) {
              uniq = [...new Set(newArray)];
          }
      });
      let data = results;
      let i = 0;
      let len = uniq.length;
      let wholeArray = [];
      let totalTime = [];
      for(i=0;i<len;i++) {
        let time = 0;
        data.map(item => {
            if(uniq[i] === moment(item.timer_start,"X").format("ddd MMM DD YYYY") && item.isStop === 1) {
                time = time + parseInt(item.timerTime);
            }
        })
        let seconds = 0;
        let minutes = 0;
        let hours = 0;
        const timerTime = time;
        seconds = (timerTime / 1000).toFixed();
        // 2- Extract hours:
        hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
        if(parseInt(hours/10) === 0) {
          hours = ("0" + hours);
        }
        seconds = seconds % 3600; // seconds remaining after extracting hours
        // 3- Extract minutes:
        minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
        // 4- Keep only seconds not extracted to minutes:
        seconds = ("0" + (seconds % 60)).slice(-2);
        //return `${hours}:${minutes}:${seconds}`;
        totalTime = [...totalTime,`${hours}:${minutes}:${seconds}`]
    }
  
    for(i=0;i<len;i++) {
      data.map((item,index) => {
          if(uniq[i] === moment(item.timer_start,"X").format("ddd MMM DD YYYY")) {
              wholeArray.push({
                       date: uniq[i],
                       totalTimeOnDay : totalTime[i], 
                       timer_id : item.timer_id,
                       title: item.title,
                       project_id: item.project_id,
                       project:item.project_name,
                       project_color : item.project_color,
                       user_id: item.user_id,
                       client_id: item.client_id,
                       client: item.client_name,  
                       workspace_id: item.workspace_id,
                       tag_id:item.tag_id,
                       tag_title: item.tag_title,
                       tagcolor : item.tagcolor,
                       timerStart: item.timerStart,
                       timerTime: item.timerTime,
                       displayTime: item.displayTime,
                       isStop: item.isStop,
                       is_billable:item.is_billable,
                       crdate: item.crdate,
                       modified_date: item.modified_date,
                       timer_start : item.timer_start,
                       timer_end : item.timer_end
              })
          }
      })
  }
  
      let array = wholeArray;
      let seen = Object.create(null);
      let arrayOfUniqData = array.filter(o => {
          var key = ['date', 'title','project','is_billable','tag_id'].map(k => o[k]).join('|');
          if (!seen[key]) {
              seen[key] = true;
              return true;
          }
      });
  
      let q = [];
      for(i = 0;i<len;i++) {
        let dataArray =  [];
        arrayOfUniqData.map(el => {
          let p = [];
          wholeArray.map(item => {
            if(uniq[i] === moment(item.timer_start,"X").format("ddd MMM DD YYYY")) {
              if(el.date === item.date && el.title === item.title &&
                el.project === item.project && 
                el.is_billable === item.is_billable &&
                el.tag_id === item.tag_id && 
                item.isStop !== 0
                ) {
                p.push(item);
              }
            }
          })
          if(p.length > 0) {
            if(p.length > 1) {
              let arrayVar = 0;
              let time = 0;
              let project = "";
              let length = p.length;
              let tag = "";
              let title = p[0].title;
              let totalTimeOnDay = p[0].totalTimeOnDay;
              let date = p[0].date;
              let timer_id_array = [];
              let maxTime = Math.max.apply(Math, p.map(function(o) { return o.timer_end; }));
              let minTime = Math.min.apply(Math, p.map(function(o) { return o.timer_start; }));
              p.map(newEl => {
                time = time + parseInt(newEl.timerTime);
                //id = id + newEl.timer_id;
                let newArr = [];
                if (!timer_id_array.includes(newEl.timer_id)) {
                  newArr = [...timer_id_array, newEl.timer_id];
                } else {
                  newArr = timer_id_array.filter((a) => a !== newEl.timer_id);
                }
                timer_id_array = newArr;
              });
              let seconds = 0;
              let minutes = 0;
              let hours = 0;
              const timerTime = time;
              seconds = (timerTime / 1000).toFixed();
              // 2- Extract hours:
              hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
              if(parseInt(hours/10) === 0) {
                hours = ("0" + hours);
              }
              seconds = seconds % 3600; // seconds remaining after extracting hours
              // 3- Extract minutes:
              minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
              // 4- Keep only seconds not extracted to minutes:
              seconds = ("0" + (seconds % 60)).slice(-2);
              let tt =  `${hours}:${minutes}:${seconds}`;
              let shiftEl = {
                date : date,
                timer_start : minTime,
                timer_end : maxTime,
                displayTime : tt,
                title : title,
                timer_id : p[0].timer_id,
                timer_id_array : timer_id_array,
                totalTimeOnDay : totalTimeOnDay
              }
              p.unshift(shiftEl);
              dataArray.push(p);
            }
            else {
              dataArray.push(p);
            }
          }
        });
        q.push(dataArray);
      }
          let inc = 0;
          let kk = {};
          for(inc = 0;inc<len;inc++) {
            if(q[inc].length > 0) {
              kk[uniq[inc]] = q[inc];
            }
          }
          return kk;
    }
    else {
      let data = results;
      let newArray = [];
      let len = results.length;
      let uniq = [];
      await results.map((item, i) => {
          newArray = [...newArray,moment(item.timer_start,"X").format("ddd MMM DD YYYY")]
          if(len === newArray.length) {
              uniq = [...new Set(newArray)];
          }
      });
      let i = 0;
      let l = uniq.length;
      let result = [];
      let totalTime = [];
      
      for(i=0;i<l;i++) {
          let time = 0;
          data.map(item => {
              if(uniq[i] === moment(item.timer_start,"X").format("ddd MMM DD YYYY") && item.isStop === 1) {
                  time = time + parseInt(item.timerTime);
              }
          })
          let seconds = 0;
          let minutes = 0;
          let hours = 0;
          const timerTime = time;
          seconds = (timerTime / 1000).toFixed();
          // 2- Extract hours:
          hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
          if(parseInt(hours/10) === 0) {
            hours = ("0" + hours);
          }
          seconds = seconds % 3600; // seconds remaining after extracting hours
          // 3- Extract minutes:
          minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
          // 4- Keep only seconds not extracted to minutes:
          seconds = ("0" + (seconds % 60)).slice(-2);
          //return `${hours}:${minutes}:${seconds}`;
          totalTime = [...totalTime,`${hours}:${minutes}:${seconds}`]
      }
  
      let jsonArray1 =  [];
      for(i=0;i<l;i++) {
         data.map((item,index) => {
             if(uniq[i] === moment(item.timer_start,"X").format("ddd MMM DD YYYY") && 
             item.isStop === 1) {
                 jsonArray1.push({
                      
                          date: uniq[i],
                          totalTimeOnDay : totalTime[i], 
                          timer_id : item.timer_id,
                          title: item.title,
                          project_id: item.project_id,
                          project:item.project_name,
                          project_color : item.project_color,
                          user_id: item.user_id,
                          client_id: item.client_id,
                          client: item.client_name,  
                          workspace_id: item.workspace_id,
                          tag_id:item.tag_id,
                          tag_title: item.tag_title,
                          tagcolor : item.tagcolor,
                          timerStart: item.timerStart,
                          timerTime: item.timerTime,
                          displayTime: item.displayTime,
                          isStop: item.isStop,
                          is_billable:item.is_billable,
                          crdate: item.crdate,
                          modified_date: item.modified_date,
                          timer_start : item.timer_start,
                          timer_end : item.timer_end
                 })
             }
         })
     }
  
      result = jsonArray1.reduce((h, obj) => 
      Object.assign(h, { [obj.date]:( h[obj.date] || [] ).concat(obj) }), {});
      return result;
    }
  }

  getVisibleRecentEntryCount = (groupedList) => {
    if (!groupedList || typeof groupedList !== 'object') {
      return 0;
    }

    return Object.values(groupedList).reduce((sum, entries) => {
      if (!Array.isArray(entries)) {
        return sum;
      }

      return sum + entries.length;
    }, 0);
  }

  getEntriesForDate = (dateKey) => {
    const zone = this.state.timezone || moment.tz.guess();
    return (this.state.heatmapEntries || this.state.timeList2 || []).filter((entry) => {
      const startRaw = Number(entry.timer_start || entry.timerStart || 0);
      if (!Number.isFinite(startRaw) || startRaw <= 0) return false;
      const normalizedStart = startRaw < 1000000000000 ? startRaw * 1000 : startRaw;
      return moment.tz(normalizedStart, zone).format('YYYY-MM-DD') === dateKey;
    });
  };

  selectRecentEntriesDate = async (dateKey) => {
    if (this.state.selectedRecentDateKey === dateKey) {
      this.clearRecentEntriesDateFilter();
      return;
    }

    // Immediately switch into selectedDay mode; null list shows skeleton while fetching
    this.setState({ selectedRecentDateKey: dateKey, selectedRecentDateList: null });

    const zone      = this.state.timezone || moment.tz.guess();
    const startUnix = moment.tz(dateKey, 'YYYY-MM-DD', zone).startOf('day').unix();
    const endUnix   = moment.tz(dateKey, 'YYYY-MM-DD', zone).endOf('day').unix();

    const scrollToList = () => {
      if (this.recentEntriesRef.current) {
        this.recentEntriesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          'Content-Type': 'application/json',
        },
      };
      const res = await axios.post('/api/usertime/list-by-date', {
        workspace_id: this.props.auth.workspace_id,
        start_unix  : startUnix,
        end_unix    : endUnix,
      }, config);

      const rawResults  = res.data.results || [];
      const groupedEntries = await this.groupByEntry(rawResults, this.state.is_group_similar);
      this.setState({ selectedRecentDateList: groupedEntries }, scrollToList);
    } catch (_err) {
      // Fallback: filter from already-loaded entries
      const filteredEntries = this.getEntriesForDate(dateKey);
      const groupedEntries  = await this.groupByEntry(filteredEntries, this.state.is_group_similar);
      this.setState({ selectedRecentDateList: groupedEntries }, scrollToList);
    }
  };

  clearRecentEntriesDateFilter = () => {
    this.setState({
      selectedRecentDateKey: null,
      selectedRecentDateList: null,
    });
  };

  buildSelectedRecentDateList = async (rawResults, dateKey, groupSimilar) => {
    if (!dateKey) {
      return null;
    }

    const zone = this.state.timezone || moment.tz.guess();
    const filteredEntries = (rawResults || []).filter((entry) => {
      const startRaw = Number(entry.timer_start || entry.timerStart || 0);
      if (!Number.isFinite(startRaw) || startRaw <= 0) return false;
      const normalizedStart = startRaw < 1000000000000 ? startRaw * 1000 : startRaw;
      return moment.tz(normalizedStart, zone).format('YYYY-MM-DD') === dateKey;
    });

    return this.groupByEntry(filteredEntries, groupSimilar);
  };

  deleteRecentEntryOptimistically = async (timerId) => {
    const filtered = this.state.timeList2.filter(
      item => item.timer_id !== timerId
    );
    const grouped = await this.groupByEntry(
      filtered,
      this.state.is_group_similar
    );
    
    this.setState({
      timeList2: filtered,
      timeList: grouped,
    });
    const numericTimerId = Number(timerId);
    if (!Number.isFinite(numericTimerId) || numericTimerId <= 0) {
      return;
    }

    const snapshot = {
      timeList: this.state.timeList,
      timeList2: this.state.timeList2,
      selectedRecentDateList: this.state.selectedRecentDateList,
      timerSyncMessage: this.state.timerSyncMessage,
      timerSyncMessageType: this.state.timerSyncMessageType,
      offset: this.state.offset,
      visibleTargetCount: this.state.visibleTargetCount,
    };

    const nextRawResults = (this.state.timeList2 || []).filter(
      (entry) => Number(entry.timer_id) !== numericTimerId
    );

    if (nextRawResults.length === (this.state.timeList2 || []).length) {
      return;
    }

    const nextGroupedEntries = await this.groupByEntry(
      nextRawResults,
      this.state.is_group_similar
    );

    const nextSelectedRecentDateList = await this.buildSelectedRecentDateList(
      nextRawResults,
      this.state.selectedRecentDateKey,
      this.state.is_group_similar
    );

    this.suppressTimerSyncUntil = Date.now() + 4000;
    this.setState({
      timeList: nextGroupedEntries,
      timeList2: nextRawResults,
      selectedRecentDateList: nextSelectedRecentDateList,
      offset: nextRawResults.length,
      visibleTargetCount: Math.max(this.getVisibleRecentEntryCount(nextGroupedEntries), 15),
      timerSyncMessage: 'Deleting entry...',
      timerSyncMessageType: 'success',
    });

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-type": "application/json",
        },
      };
      const body = JSON.stringify({
        timer_id: numericTimerId,
        is_workspace_admin: this.props.auth.is_workspace_admin,
      });
      await axios.post("/api/usertime/delete", body, config);
      this.setState({
        timerSyncMessage: '',
        timerSyncMessageType: 'success',
      });
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
      this.setState({
        ...snapshot,
        timerSyncMessage: 'Could not delete this entry. Restored it.',
        timerSyncMessageType: 'danger',
      });
      if (this.timerSyncToastTimer) clearTimeout(this.timerSyncToastTimer);
      this.timerSyncToastTimer = setTimeout(() => {
        this.setState({ timerSyncMessage: "", timerSyncMessageType: "success" });
      }, 3000);
      throw err;
    }
  };

  fetchRecentEntriesPage = async (offset) => {
    const config = {
      headers: {
        Authorization: `Bearer ${this.props.auth.token}`,
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      workspace_id: this.props.auth.workspace_id,
      offset,
    });
    const res = await axios.post("/api/usertime/list", body, config);
    if (res.status !== 200) {
      return { results: [], running: [] };
    }
    return res.data;
  }

  fetchHeatmapEntries = async () => {
    const workspaceId = this.props.auth.workspace_id;
    if (!workspaceId) {
      this.setState({ heatmapEntries: [] });
      return;
    }

    const zone = this.state.timezone || moment.tz.guess();
    const end = moment.tz(zone).endOf('month');
    const start = end.clone().subtract(17, 'months').startOf('month');
    const config = {
      headers: {
        Authorization: `Bearer ${this.props.auth.token}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const res = await axios.post("/api/report/calendar_data", {
        workspace_id: workspaceId,
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD'),
      }, config);

      this.setState({
        heatmapEntries: Array.isArray(res.data?.results) ? res.data.results : [],
      });
    } catch (err) {
      console.log(err);
      this.setState({ heatmapEntries: [] });
    }
  }

  loadRecentEntriesUntilFilled = async ({ startOffset = 0, minimumVisibleEntries = 15, groupSimilar = false, seedResults = [] } = {}) => {
    let rawResults = [...seedResults];
    let offset = startOffset;
    let grouped = {};
    let visibleCount = 0;

    while (true) {
      const page = await this.fetchRecentEntriesPage(offset);
      const pageResults = Array.isArray(page.results) ? page.results : [];
      rawResults = rawResults.concat(pageResults);
      offset += pageResults.length;
      grouped = await this.groupByEntry(rawResults, groupSimilar);
      visibleCount = this.getVisibleRecentEntryCount(grouped);

      if (visibleCount >= minimumVisibleEntries || pageResults.length < 15) {
        return {
          grouped,
          rawResults,
          offset,
          visibleCount,
          running: Array.isArray(page.running) ? page.running : [],
        };
      }
    }
  }

  /*listFunction = async (results) => {
    
  }*/

  startPage = async (refreshOnly = false) => {
    try {
      const hadRunningTimer = this.state.isStop === 0;
      let is_group_similar = await this.getProfile();
      this.fetchHeatmapEntries();
      if (!refreshOnly) {
        this.fetchWeeklyChartData();
        this.fetchSuggestions();
      }
      const initialPage = await this.fetchRecentEntriesPage(0);
      const initialResults = Array.isArray(initialPage.results) ? initialPage.results : [];
      const initialRunning = Array.isArray(initialPage.running) ? initialPage.running : [];

      let groupedEntries = await this.groupByEntry(initialResults, is_group_similar);
      let rawResults = [...initialResults];
      let offsetLength = initialResults.length;

      const initialVisibleCount = this.getVisibleRecentEntryCount(groupedEntries);
      if (initialVisibleCount < 15 && initialResults.length === 15) {
        const filled = await this.loadRecentEntriesUntilFilled({
          startOffset: initialResults.length,
          minimumVisibleEntries: 15,
          groupSimilar: is_group_similar,
          seedResults: initialResults,
        });
        groupedEntries = filled.grouped;
        rawResults = filled.rawResults;
        offsetLength = filled.offset;
      }

      const nextSelectedRecentDateList = await this.buildSelectedRecentDateList(
        rawResults,
        this.state.selectedRecentDateKey,
        is_group_similar
      );

      let lastRow;
      if (initialRunning.length > 0) {
        lastRow = initialRunning[0];
      }
      if (lastRow == "" || lastRow === undefined || lastRow === null) {
        lastRow = rawResults[0];
      }
      if (lastRow !== undefined) {
        if (lastRow.isStop === 0) {
          if (
            lastRow.tag_id !== null &&
            lastRow.tag_id !== undefined &&
            lastRow.tag_id !== ""
          ) {
            let arr = [];
            arr = lastRow.tag_id.split(",");
            let trueArr = [];
            arr.map((item) => {
              trueArr.push(Number(item));
            });
            if (arr.length === trueArr.length) {
              this.setState({ tag_check_array: trueArr });
            }
          }
          let m1 = moment(lastRow.timer_start,'X');
          let dd = m1.date();
          let MM = m1.month();
          let yy = m1.year();
          let m = moment({ year :yy, month :MM, day :dd})._d;
          this.setState({
            runningTimerStart : moment.unix(lastRow.timer_start).format(this.state.timeFormat),
            manualDate : m,
            timeList: groupedEntries,
            timeList2 : rawResults,
            timerStart: parseInt(lastRow.timerStart),
            timer_start: parseInt(lastRow.timer_start),
            timer_id: lastRow.timer_id,
            isStop: lastRow.isStop,
            is_billable: lastRow.is_billable,
            title: lastRow.title,
            project_id: lastRow.project_id,
            project: lastRow.project_name,
            client_id: lastRow.client_id,
            client: lastRow.client_name,
            projectAutoMatched: false,
            projectSelectionSource:
              this.state.projectSelectionSource === "manual" ? "manual" : "auto",
            workspace_id: lastRow.workspace_id,
            offset : offsetLength,
            selectedRecentDateList: nextSelectedRecentDateList,
            loading : false,
          }, () => {
            if (!refreshOnly) {
              this.selectWorkspace(lastRow.workspace_id);
              this.getWorkspaceInfo(lastRow.workspace_id);
              this.projectList(lastRow.workspace_id);
              this.tagList(lastRow.workspace_id);
            }
            this.startTimerTicker(parseInt(lastRow.timerStart));
          });
        } else {
          const nextState = {
            timeList: groupedEntries,
            timeList2: rawResults,
            isStop: 1,
            timerStart: 0,
            timerTime: 0,
            offset: offsetLength,
            selectedRecentDateList: nextSelectedRecentDateList,
            loading: false,
          };

          if (hadRunningTimer) {
            Object.assign(nextState, {
              timer_start: 0,
              timer_end: 0,
              timer_id: "",
              title: "",
              project_id: "",
              project: "",
              client_id: "",
              client: "",
              projectSelectionSource: "",
              tag_check_array: [],
              is_billable: 0,
              runningTimerStart: "",
            });
          }

          this.setState({
            ...nextState,
          });
          if (!refreshOnly) {
            this.projectList();
            this.tagList();
            this.getWorkspaceInfo();
          }
        }
      } else {
        const nextState = {
          timeList: groupedEntries,
          timeList2: rawResults,
          isStop: 1,
          timerStart: 0,
          timerTime: 0,
          offset: offsetLength,
          selectedRecentDateList: nextSelectedRecentDateList,
          loading: false,
        };

        if (hadRunningTimer) {
            Object.assign(nextState, {
              timer_start: 0,
              timer_end: 0,
              timer_id: "",
              title: "",
              project_id: "",
              project: "",
              client_id: "",
              client: "",
              projectSelectionSource: "",
              tag_check_array: [],
              is_billable: 0,
              runningTimerStart: "",
          });
        }

        this.setState({
          ...nextState,
        });
        if (!refreshOnly) {
          this.projectList();
          this.tagList();
          this.getWorkspaceInfo();
        }
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  fetchSuggestions = async () => {
    try {
      const workspace_id = this.props.auth.workspace_id;
      if (!workspace_id) {
        this.setState({ suggestions: [], suggestionsLoading: false });
        return;
      }

      this.setState({ suggestionsLoading: true });
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
        params: { workspace_id },
      };

      const res = await axios.get("/api/time-suggestions/list", config);
      if (res.status === 200) {
        const suggestions = res.data.results || [];
        this.setState({
          suggestions,
          suggestionsLoading: false,
          suggestionCursor: 0,
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({ suggestionsLoading: false });
    }
  };

  readExtensionTimerLaunch = () => {
    let title = "";
    let source = "chrome-extension";
    let taskId = "", action = "start", requestId = "";

    try {
      const params = new URLSearchParams(this.props.location?.search || "");
      title = (params.get("startTimerText") || "").trim();
      source = params.get("source") || source;
      if (/^\d{1,30}$/.test(params.get('asanaTask') || '')) {
        requestId=params.get('asanaRequest') || ''; taskId=params.get('asanaTask'); action=params.get('asanaAction') || 'start'; title=tr("Asana task");
      }
      if (title) {
        sessionStorage.setItem(
          "mz_extension_timer_launch",
          JSON.stringify({ title, source, taskId, action, requestId })
        );
      }
    } catch (err) {}

    if (!title) {
      try {
        const raw =
          sessionStorage.getItem("mz_extension_timer_launch") ||
          localStorage.getItem("mz_extension_timer_launch");
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed && typeof parsed.title === "string") {
            title = parsed.title.trim();
            source = parsed.source || source;
            requestId = parsed.requestId || ""; taskId = parsed.taskId || ""; action = parsed.action || "start";
          }
        }
      } catch (err) {}
    }

    if (!title) {
      return null;
    }

    return { title, source, taskId, action, requestId };
  };

  clearExtensionTimerLaunch = () => {
    try {
      sessionStorage.removeItem("mz_extension_timer_launch");
    } catch (err) {}

    try {
      localStorage.removeItem("mz_extension_timer_launch");
    } catch (err) {}

    try {
      const params = new URLSearchParams(this.props.location?.search || "");
      if (params.has("startTimerText") || params.has("source") || params.has("asanaTask")) {
        params.delete("startTimerText");
        params.delete("source");
        params.delete("asanaTask"); params.delete("asanaAction"); params.delete("asanaRequest");
        const nextSearch = params.toString();
        this.props.history.replace(
          `${this.props.location?.pathname || "/dashboard"}${nextSearch ? `?${nextSearch}` : ""}`
        );
      }
    } catch (err) {}
  };

  tryLaunchPendingExtensionTimer = async () => {
    if (!this.pendingExtensionLaunch || this.extensionLaunchInProgress || this.state.loading) {
      return;
    }

    const workspace_id = this.state.workspace_id || this.props.auth.workspace_id || 0;
    if (!workspace_id || !this.props.auth.isAuthenticated) {
      return;
    }

    this.extensionLaunchInProgress = true;
    const pending = this.pendingExtensionLaunch;

    try {
      if (pending.taskId) {
        // The provider verifies task/project access; no task title or project is trusted from the URL.
        await axios.post('/api/integrations/asana/start-task', {workspace_id,task_id:pending.taskId,action:pending.action}, this.asanaConfig());
        this.pendingExtensionLaunch=null; this.clearExtensionTimerLaunch();
        window.postMessage({type:'minutezilla:asana-result',requestId:pending.requestId,ok:true},window.location.origin);
        // Refresh the dashboard if this is a direct link without an extension bridge.
        setTimeout(()=>window.location.reload(),1000); return;
      }
      await this.triggerExtensionTimerLaunch({
        title: pending.title,
        workspace_id,
      });
      this.pendingExtensionLaunch = null;
      this.clearExtensionTimerLaunch();
    } catch (err) {
      this.pendingExtensionLaunch=null; this.clearExtensionTimerLaunch();
      if(pending.taskId) window.postMessage({type:'minutezilla:asana-result',requestId:pending.requestId,ok:false,error:err.response?.data?.msg || tr("Open Minutezilla to connect Asana and sync this project.")},window.location.origin);
      this.setState({asanaError:err.response?.data?.msg || tr("The timer could not be started. Connect Asana and sync its project in Integrations.")});
    } finally {
      this.extensionLaunchInProgress = false;
    }
  };

  triggerExtensionTimerLaunch = async ({ title, workspace_id }) => {
    return this.startTimerFromExtensionLaunchWithAutofill(title, workspace_id);
  };

  stopRunningTimerForExtensionLaunch = async () => {
    const snapshot = {
      title: this.state.title,
      workspace_id:
        this.state.workspace_id !== 0 &&
        this.state.workspace_id !== null &&
        this.state.workspace_id !== undefined
          ? this.state.workspace_id
          : this.props.auth.workspace_id,
      client_id: this.state.client_id,
      project_id: this.state.project_id,
      timerStart: this.state.timerStart,
      timerTime: this.state.timerTime,
      timer_id: this.state.timer_id,
      tag_check_array: this.state.tag_check_array,
      is_billable: this.state.is_billable,
      timer_start: this.state.timer_start,
    };

    const liveStartedAt = Number(snapshot.timerStart || this.activeTimerStart || 0);
    const liveElapsedMs = liveStartedAt > 0 ? Math.max(0, Date.now() - liveStartedAt) : 0;
    const normalizedTimerTime = Math.max(Number(snapshot.timerTime || 0), liveElapsedMs);
    const timerEnd = moment().unix();

    clearInterval(this.timer);
    clearInterval(this.timer2);
    this.activeTimerStart = null;
    document.title = `Minutezilla`;

    const config = {
      headers: {
        Authorization: `Bearer ${this.props.auth.token}`,
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      timer_id: snapshot.timer_id,
      workspace_id: snapshot.workspace_id,
      title: snapshot.title,
      client_id: snapshot.client_id,
      project_id: snapshot.project_id,
      timerStart: snapshot.timerStart,
      timer_start: snapshot.timer_start,
      timer_end: timerEnd,
      timerTime: normalizedTimerTime,
      isStop: 1,
      is_billable: snapshot.is_billable,
      tag_check_array: snapshot.tag_check_array,
    });

    const res = await axios.put("/api/usertime/update", body, config);
    if (res.status === 200) {
      let m1 = moment();
      let dd = m1.date();
      let MM = m1.month();
      let yy = m1.year();
      let m = moment({ year :yy, month :MM, day :dd})._d;

      this.setState({
        timerTime: 0,
        timerStart: 0,
        isStop: 1,
        title: "",
        project: "",
        project_id: "",
        client: "",
        client_id: "",
        tag_check_array: [],
        is_billable: 0,
        manualDate : m
      });
      this.startPage();
    }
  };

  ensureExtensionLaunchStopsRunningTimer = async () => {
    if (this.state.isStop === 0 && this.state.timerStart !== 0) {
      await this.stopRunningTimerForExtensionLaunch();
    }
  };

  startTimerFromExtensionLaunch = async (rawTitle, workspace_id, options = {}) => {
    const title = String(rawTitle || "").trim();
    if (!title) {
      throw new Error("Extension launch is missing a timer title.");
    }

    if (!options.skipExistingStop) {
      await this.ensureExtensionLaunchStopsRunningTimer();
    }

    const matchedProject = this.resolveProjectMatchFromTitle(title);
    const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");
    const timeInSeconds = moment(currentDate).unix();
    const startedAt = Date.now();
    const client_id = matchedProject ? (matchedProject.client_id || "") : "";
    const project_id = matchedProject ? (matchedProject.id || "") : "";
    const is_billable = matchedProject ? (matchedProject.isbillable === 1 ? 1 : 0) : 0;

    await new Promise((resolve) => {
      this.setState(
        {
          title,
          workspace_id,
          client_id,
          project_id,
          project: matchedProject?.project_name || "",
          client: matchedProject?.client_name || "",
          is_billable,
          isStop: 0,
          timerStart: startedAt,
          timer_start: timeInSeconds,
          timerNow: Date.now(),
          timerTime: 0,
          tag_check_array: [],
          titleError: false,
          autofilled: false,
          autofilledProject: !!matchedProject,
          projectAutoMatched: !!matchedProject,
          projectSelectionSource: matchedProject ? "auto" : "",
        },
        resolve
      );
    });

    this.activeTimerStart = startedAt;
    this.startTimerTicker(startedAt);

    const config = {
      headers: {
        Authorization: `Bearer ${this.props.auth.token}`,
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      workspace_id,
      title,
      client_id,
      project_id,
      timerStart: startedAt,
      timer_start: timeInSeconds,
      timerTime: 0,
      isStop: 0,
      is_billable,
      tag_check_array: [],
    });

    const res = await axios.post("/api/usertime/create", body, config);
    if (res.status === 200) {
      this.setState({
        timer_id: res.data.results.timer_id,
        runningTimerStart: moment.unix(timeInSeconds).format(this.state.timeFormat),
      });
      return;
    }

    throw new Error("Could not create timer from extension launch.");
  };

  startTimerFromExtensionLaunchWithAutofill = async (rawTitle, workspace_id) => {
    const title = String(rawTitle || "").trim();
    if (!title) {
      throw new Error("Extension launch is missing a timer title.");
    }

    await this.ensureExtensionLaunchStopsRunningTimer();

    const recentEntryMatch = this.resolveRecentEntryMatchFromTitle(title);
    if (!recentEntryMatch) {
      return this.startTimerFromExtensionLaunch(title, workspace_id, { skipExistingStop: true });
    }

    const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");
    const timeInSeconds = moment(currentDate).unix();
    const startedAt = Date.now();
    const client_id = recentEntryMatch.client_id;
    const project_id = recentEntryMatch.project_id;
    const is_billable = recentEntryMatch.is_billable;
    const tag_check_array = recentEntryMatch.tag_check_array;

    await new Promise((resolve) => {
      this.setState(
        {
          title,
          workspace_id,
          client_id,
          project_id,
          project: recentEntryMatch.project,
          client: recentEntryMatch.client,
          is_billable,
          isStop: 0,
          timerStart: startedAt,
          timer_start: timeInSeconds,
          timerNow: Date.now(),
          timerTime: 0,
          tag_check_array,
          titleError: false,
          autofilled: true,
          autofilledProject: project_id !== "",
          projectAutoMatched: false,
          projectSelectionSource: project_id !== "" ? "manual" : "",
          autofilledTags: tag_check_array.length > 0,
          autofilledBillable: is_billable === 1,
        },
        resolve
      );
    });

    this.activeTimerStart = startedAt;
    this.startTimerTicker(startedAt);

    const config = {
      headers: {
        Authorization: `Bearer ${this.props.auth.token}`,
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      workspace_id,
      title,
      client_id,
      project_id,
      timerStart: startedAt,
      timer_start: timeInSeconds,
      timerTime: 0,
      isStop: 0,
      is_billable,
      tag_check_array,
    });

    const res = await axios.post("/api/usertime/create", body, config);
    if (res.status === 200) {
      this.setState({
        timer_id: res.data.results.timer_id,
        runningTimerStart: moment.unix(timeInSeconds).format(this.state.timeFormat),
      });
      return;
    }

    throw new Error("Could not create timer from extension launch.");
  };

  acceptSuggestion = async (suggestion) => {
    try {
      this.setState({ suggestionActionId: suggestion.id });
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      const body = JSON.stringify({ workspace_id: this.props.auth.workspace_id });
      const res = await axios.post(`/api/time-suggestions/${suggestion.id}/accept`, body, config);

      if (res.status === 200) {
        this.setState((prev) => {
          const suggestions = prev.suggestions.filter((item) => item.id !== suggestion.id);
          return {
            suggestions,
            suggestionCursor: suggestions.length ? Math.min(prev.suggestionCursor, suggestions.length - 1) : 0,
            suggestionMessage: 'Suggestion logged successfully.',
            suggestionMessageType: 'success',
          };
        });
        await this.startPage();
      }
    } catch (err) {
      console.log(err);
      const message =
        err?.response?.data?.errors?.[0]?.msg ||
        err?.response?.data?.msg ||
        tr("Could not log this suggestion. Please try again.");
      this.setState({
        suggestionMessage: message,
        suggestionMessageType: 'danger',
      });
    } finally {
      this.setState({ suggestionActionId: null });
    }
  };

  dismissSuggestion = async (suggestionId) => {
    try {
      this.setState({ suggestionActionId: suggestionId });
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      const body = JSON.stringify({ workspace_id: this.props.auth.workspace_id });
      const res = await axios.post(`/api/time-suggestions/${suggestionId}/dismiss`, body, config);

      if (res.status === 200) {
        this.setState((prev) => {
          const suggestions = prev.suggestions.filter((item) => item.id !== suggestionId);
          return {
            suggestions,
            suggestionCursor: suggestions.length ? Math.min(prev.suggestionCursor, suggestions.length - 1) : 0,
            suggestionMessage: 'Suggestion dismissed.',
            suggestionMessageType: 'success',
          };
        });
        await this.fetchSuggestions();
      }
    } catch (err) {
      console.log(err);
      const message =
        err?.response?.data?.errors?.[0]?.msg ||
        err?.response?.data?.msg ||
        tr("Could not dismiss this suggestion. Please try again.");
      this.setState({
        suggestionMessage: message,
        suggestionMessageType: 'danger',
      });
    } finally {
      this.setState({ suggestionActionId: null });
    }
  };

  formatSuggestionWindow = (start, end) => {
    const startMoment = moment(start);
    const isToday = startMoment.isSame(moment(), 'day');
    const isYesterday = startMoment.isSame(moment().subtract(1, 'day'), 'day');
    const dateLabel = isToday ? tr("Today") : isYesterday ? tr("Yesterday") : startMoment.format('ddd, MMM D');
    const format = this.state.timeFormat || (
      this.props.auth.user_properties
        ? alterTimeFormat(this.props.auth.user_properties.timeFormat)
        : "hh:mm A"
    );
    return `${dateLabel} · ${startMoment.format(format)} – ${moment(end).format(format)}`;
  };

  goToPreviousSuggestion = () => {
    this.setState((prev) => ({
      suggestionCursor: prev.suggestions.length
        ? (prev.suggestionCursor - 1 + prev.suggestions.length) % prev.suggestions.length
        : 0,
    }));
  };

  goToNextSuggestion = () => {
    this.setState((prev) => ({
      suggestionCursor: prev.suggestions.length
        ? (prev.suggestionCursor + 1) % prev.suggestions.length
        : 0,
    }));
  };

  getProfile = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = this.props.auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post("/api/profile/info", body, config);
      if (res.status === 200) {
        if(res.data.results[1][0].is_group_similar_entries === 1) {
          this.setState({is_group_similar : true});
          return true;
        }
        else {
          this.setState({is_group_similar : false});
          return false;
        }
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  titleOnChange = (e) => {
    const title = e.target.value;
    this.setState({ title }, () => {
      this.syncProjectFromTitle(title);
    });
  };

  titleOnPaste = (e) => {
    const pasted = e.clipboardData.getData('text').trim();
    if (!pasted) return;

    // Find the most recent entry with an exact title match
    const match = (this.state.timeList2 || [])
      .filter(item => item.title === pasted)
      .sort((a, b) => (b.timer_start || 0) - (a.timer_start || 0))[0];

    if (!match) return; // no match — paste normally

    // Parse comma-separated tag_ids into an array of numbers
    const tag_check_array =
      match.tag_id && match.tag_id !== '' && match.tag_id !== null
        ? String(match.tag_id).split(',').map(Number).filter(Boolean)
        : [];
    const normalizedProjectId =
      match.project_id === null || match.project_id === undefined || match.project_id === ""
        ? ""
        : Number(match.project_id);
    const normalizedClientId =
      match.client_id === null || match.client_id === undefined || match.client_id === ""
        ? ""
        : Number(match.client_id);

    // Prevent default paste so we can set state with the full title
    e.preventDefault();
    this.setState({
      title        : pasted,
      project_id   : normalizedProjectId,
      project      : match.project_name || match.project || '',
      client_id    : normalizedClientId,
      client       : match.client_name  || match.client  || '',
      is_billable  : match.is_billable  || 0,
      tag_check_array,
      titleError         : false,
      autofilled         : true,
      autofilledProject  : normalizedProjectId !== "",
      projectAutoMatched : false,
      projectSelectionSource : normalizedProjectId !== "" ? "manual" : "",
      autofilledTags     : true,
      autofilledBillable : (match.is_billable || 0) === 1,
    });
  };

  searchTermOnChange = (e) => {
    const searchTerm = e.target.value;
    this.setState({ searchTerm }, () => {
      this.projectList(undefined, undefined, searchTerm);
    });
  };

  normalizeProjectText = (text) => {
    return String(text || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/gi, " ")
      .trim()
      .replace(/\s+/g, " ");
  };

  getProjectMatches = (title) => {
    const normalizedTitle = this.normalizeProjectText(title);
    if (!normalizedTitle.trim()) return [];

    const source = Object.keys(this.state.projectCatalog || {}).length > 0
      ? this.state.projectCatalog
      : this.state.projectArray;

    const projects = Object.values(source || {}).reduce((acc, group) => {
      if (Array.isArray(group)) {
        acc.push(...group);
      }
      return acc;
    }, []);

    const titleWords = new Set(normalizedTitle.split(" ").filter(Boolean));

    return projects
      .filter((item) => {
        if (!item || Number(item.id) === 0) return false;
        const projectName = this.normalizeProjectText(item.project_name);
        if (!projectName) return false;
        // Exact substring match (original behaviour)
        if (normalizedTitle.includes(projectName)) return true;
        // Word-set match: every word in the project name appears in the title
        const projectWords = projectName.split(" ").filter(Boolean);
        return projectWords.length > 0 && projectWords.every(w => titleWords.has(w));
      })
      .sort((a, b) => String(b.project_name || "").length - String(a.project_name || "").length);
  };

  resolveProjectMatchFromTitle = (title) => {
    return this.getProjectMatches(title)[0] || null;
  };

  resolveRecentEntryMatchFromTitle = (title) => {
    const normalizedTitle = String(title || "").trim();
    if (!normalizedTitle) {
      return null;
    }

    const match = (this.state.timeList2 || [])
      .filter((item) => item.title === normalizedTitle)
      .sort((a, b) => (b.timer_start || 0) - (a.timer_start || 0))[0];

    if (!match) {
      return null;
    }

    const tag_check_array =
      match.tag_id && match.tag_id !== '' && match.tag_id !== null
        ? String(match.tag_id).split(',').map(Number).filter(Boolean)
        : [];
    const normalizedProjectId =
      match.project_id === null || match.project_id === undefined || match.project_id === ""
        ? ""
        : Number(match.project_id);
    const normalizedClientId =
      match.client_id === null || match.client_id === undefined || match.client_id === ""
        ? ""
        : Number(match.client_id);

    return {
      project_id: normalizedProjectId,
      project: match.project_name || match.project || '',
      client_id: normalizedClientId,
      client: match.client_name || match.client || '',
      is_billable: match.is_billable || 0,
      tag_check_array,
    };
  };

  syncProjectFromTitle = (title) => {
    if (this.state.projectSelectionSource === "manual") {
      return;
    }

    const match = this.resolveProjectMatchFromTitle(title);

    if (this.state.projectAutoMatched === true) {
      const stillMatches =
        match && Number(this.state.project_id) === Number(match.id);

      if (stillMatches) {
        return;
      }

      this.setState({
        project: "",
        project_id: "",
        client: "",
        client_id: "",
        project_color: "",
        is_billable: 0,
        projectAutoMatched: false,
        projectSelectionSource: "",
      });
    }
  };

  updateTitleTag(timerTime, title) {
    if (this.state.timerTime !== 0 && this.state.isStop !== 1) {
          let seconds = (timerTime / 1000).toFixed();
          // 2- Extract hours:
          let hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
          if(parseInt(hours/10) === 0) {
            hours = ("0" + hours);
          }
          seconds = seconds % 3600; // seconds remaining after extracting hours
          // 3- Extract minutes:
          let minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
          // 4- Keep only seconds not extracted to minutes:
          seconds = ("0" + (seconds % 60)).slice(-2);
          //return `${hours}:${minutes}:${seconds}`;
      document.title = `${hours}:${minutes}:${seconds} - ${title || "Minutezilla"}`;
      return;
    }
    document.title = "Minutezilla";
  }

  fetchCheckinStatus = async () => {
    const workspace_id = this.props.auth.workspace_id;
    if (!workspace_id) return;
    const config = { headers: { Authorization: `Bearer ${this.props.auth.token}` } };
    try {
      const [policyRes, todayRes] = await Promise.all([
        axios.get(`/api/compliance/policy?workspace_id=${workspace_id}`, config),
        axios.get(`/api/attendance/today?workspace_id=${workspace_id}`, config),
      ]);
      const requireCheckInOut = !!policyRes.data?.policy?.settings?.requireCheckInOut;
      const isCheckedIn = !!todayRes.data?.is_checked_in;
      this.setState({ requireCheckInOut, isCheckedIn });
    } catch { this.setState({ requireCheckInOut: true }); }
  };

  handleCheckinAndStart = async () => {
    this.setState({ checkinPromptLoading: true });
    const workspace_id = this.props.auth.workspace_id;
    const config = {
      headers: { Authorization: `Bearer ${this.props.auth.token}`, 'Content-Type': 'application/json' },
    };
    try {
      await axios.post('/api/attendance/check-in', JSON.stringify({ workspace_id }), config);
      this.setState({ isCheckedIn: true, checkinPromptShow: false, checkinPromptLoading: false }, () => {
        this.startTimer();
      });
    } catch (err) {
      const msg = err.response?.data?.errors?.[0]?.msg || tr("Check-in failed");
      this.setState({ checkinPromptLoading: false, checkinPromptShow: false });
      alert(msg);
    }
  };

  handleSkipCheckin = () => {
    this.setState({ checkinPromptShow: false }, () => {
      this._skipCheckinGate = true;
      this.startTimer();
    });
  };

  startTimerTicker = (startedAt) => {
    if (!startedAt) return;
    clearInterval(this.timer);
    this.setState({ timerTime: Date.now() - startedAt });
    this.timer = setInterval(() => {
      const elapsed = Date.now() - startedAt;
      this.setState({ timerTime: elapsed });
      this.updateTitleTag(elapsed, this.state.title);
    }, 1000);
  }

  startTimer = async () => {
    // resume the timer
    if (this.state.isStop === 0 && this.state.timerStart !== 0) {
      try {
        const startedAt = Number(this.state.timerStart) || Date.now();
        this.activeTimerStart = startedAt;
        this.startTimerTicker(startedAt);
        const config = {
          headers: {
            Authorization: `Bearer ${this.props.auth.token}`,
            "Content-Type": "application/json",
          },
        };
        let currentDate = moment().format("YYYY-MM-DD HH:mm:ss");//.unix());  
        let timeInSeconds = moment(currentDate).unix();
        let title = this.state.title;
        let workspace_id =
          this.state.workspace_id !== 0 &&
          this.state.workspace_id !== null &&
          this.state.workspace_id !== undefined
            ? this.state.workspace_id
            : this.props.auth.workspace_id;

        let client_id = this.state.client_id;
        let project_id = this.state.project_id;
        let timerStart = this.state.timerStart;
        let timerTime = this.state.timerTime;
        let isStop = this.state.isStop;
        let tag_check_array = this.state.tag_check_array;
        let timer_id = this.state.timer_id;
        let is_billable = this.state.is_billable;
        let timer_start = this.state.timer_start;
        let timer_end = timeInSeconds;

        const body = JSON.stringify({
          timer_id,
          workspace_id,
          title,
          client_id,
          project_id,
          timerStart,
          timer_start,
          timer_end,
          timerTime,
          isStop,
          is_billable,
          tag_check_array,
        });
        let res = await axios.put("/api/usertime/update", body, config);
        /*if(res.status === 200) {
          console.log(moment.unix(this.state.timer_start).format("hh:mm a"))
          this.setState({
            runningTimerStart : moment.unix(this.state.timer_start).format(this.state.timeFormat)
          })
        }*/
      } catch (err) {
        console.log(err);
        if (err.response) {
          console.log(err.response);
        }
      }
    }
    ////////////// start new timer
    else {
      if (!this.state.title || this.state.title.trim() === "") {
        this.setState({ titleError: true });
        setTimeout(() => this.setState({ titleError: false }), 3000);
        return;
      }
      if (this.state.requireCheckInOut && !this.state.isCheckedIn && !this._skipCheckinGate) {
        this.setState({ checkinPromptShow: true });
        return;
      }
      this._skipCheckinGate = false;
      const matchedProject = this.resolveProjectMatchFromTitle(this.state.title);
      if (matchedProject) {
        const nextProjectState = {
          project: matchedProject.project_name || "",
          project_id: matchedProject.id || "",
          client: matchedProject.client_name || "",
          client_id: matchedProject.client_id || "",
          project_color: matchedProject.project_color || "",
          is_billable: matchedProject.isbillable === 1 ? 1 : 0,
          projectOpen: false,
          showAllProjects: false,
          projectAutoMatched: true,
          projectSelectionSource: "auto",
          autofilledProject: true,
        };
        this.setState(nextProjectState);
      } else if (this.state.projectSelectionSource === "auto") {
        this.setState({
          project: "",
          project_id: "",
          client: "",
          client_id: "",
          project_color: "",
          is_billable: 0,
          projectAutoMatched: false,
          projectSelectionSource: "",
        });
      }
      let currentDate = moment().format("YYYY-MM-DD HH:mm:ss");//.unix());
      let timeInSeconds = moment(currentDate).unix();
      const startedAt = Date.now();
      this.setState({ isStop: 0, timerStart: startedAt, timer_start: timeInSeconds, timerNow: Date.now() }, 
      async () => {
        this.activeTimerStart = startedAt;
        this.startTimerTicker(startedAt);
        const config = {
          headers: {
            Authorization: `Bearer ${this.props.auth.token}`,
            "Content-Type": "application/json",
          },
        };
        let title = this.state.title;
        let workspace_id =
          this.state.workspace_id !== 0 &&
          this.state.workspace_id !== null &&
          this.state.workspace_id !== undefined
            ? this.state.workspace_id
            : this.props.auth.workspace_id;
        let client_id = matchedProject ? (matchedProject.client_id || "") : this.state.client_id;
        let project_id = matchedProject ? (matchedProject.id || "") : this.state.project_id;
        let is_billable = matchedProject
          ? (matchedProject.isbillable === 1 ? 1 : 0)
          : this.state.is_billable;
        let timerStart = this.state.timerStart;
        let timerTime = this.state.timerTime;
        let isStop = this.state.isStop;
        let tag_check_array = this.state.tag_check_array;
        let timer_start = this.state.timer_start

        const body = JSON.stringify({
          workspace_id,
          title,
          client_id,
          project_id,
          timerStart,
          timer_start,
          timerTime,
          isStop,
          is_billable,
          tag_check_array,
        });
        let res = await axios.post("/api/usertime/create", body, config);
        if (res.status === 200) {
          this.setState({ timer_id: res.data.results.timer_id,
            runningTimerStart : moment.unix(timer_start).format(this.state.timeFormat) });
        }
      });
    }
  };

  secondTimer = async (item) => {
    if (this.state.requireCheckInOut && !this.state.isCheckedIn) {
      this.setState({
        title: item.title,
        project_id: item.project_id === null || item.project_id === undefined || item.project_id === "" ? "" : Number(item.project_id),
        client_id: item.client_id === null || item.client_id === undefined || item.client_id === "" ? "" : Number(item.client_id),
        is_billable: item.is_billable,
        checkinPromptShow: true,
      });
      return;
    }
    try {
      if (this.state.isStop == 0 && this.state.timerStart !== 0) {
        await this.stopTimer();
      }
      if(this.state.isStop == 0 && this.state.timerStart !== 0) {
        this.callPopOverFunctionEnter();
        setTimeout(() => {
          this.setState({
            showPopOver : false
          })
        }, 3000);
      }
      else {
        const normalizedProjectId =
          item.project_id === null || item.project_id === undefined || item.project_id === ""
            ? ""
            : Number(item.project_id);
        const normalizedClientId =
          item.client_id === null || item.client_id === undefined || item.client_id === ""
            ? ""
            : Number(item.client_id);
        let trueArr = [];
        if (
          item.tag_id !== null &&
          item.tag_id !== undefined &&
          item.tag_id !== ""
        ) {
          
          let arr = [];
          arr = item.tag_id.split(",");
    
          arr.map((item) => {
            trueArr.push(Number(item));
          });
        }
        this.selectWorkspace(item.workspace_id);
        this.getWorkspaceInfo(item.workspace_id);
        this.carryAsanaTask(item, true);
    
        let currentDate = moment().format("YYYY-MM-DD HH:mm:ss");//.unix());  
        let timeInSeconds = moment(currentDate).unix();
    
        this.setState(
          {
            isStop: 0,
            timerStart: Date.now(),
            timer_start : timeInSeconds,
            timerNow: Date.now(),
            project_id: normalizedProjectId,
            workspace_id: item.workspace_id,
            client_id: normalizedClientId,
            project: item.project_name || item.project,
            client: item.client_name || item.client,
            title: item.title,
            tag_check_array: trueArr,
            is_billable: item.is_billable,
            projectAutoMatched: false,
            projectSelectionSource: normalizedProjectId !== "" ? "manual" : "",
            autofilledProject: normalizedProjectId !== "",
          },
          async () => {
            const startedAt = Number(this.state.timerStart) || Date.now();
            this.activeTimerStart = startedAt;
            this.startTimerTicker(startedAt);
            const config = {
              headers: {
                Authorization: `Bearer ${this.props.auth.token}`,
                "Content-Type": "application/json",
              },
            };
            let title = this.state.title;
            let workspace_id = this.state.workspace_id;
            let client_id = this.state.client_id;
            let project_id = this.state.project_id;
            let timerStart = this.state.timerStart;
            let timerTime = this.state.timerTime;
            let isStop = this.state.isStop;
            let tag_check_array = this.state.tag_check_array;
            let is_billable = this.state.is_billable;
            let timer_start = this.state.timer_start;
    
            const body = JSON.stringify({
              workspace_id,
              title,
              client_id,
              project_id,
              timerStart,
              timer_start,
              timerTime,
              isStop,
              is_billable,
              tag_check_array,
            });
            let res = await axios.post("/api/usertime/create", body, config);
            if (res.status === 200) {
              this.setState({ timer_id: res.data.results.timer_id });
            }
          }
        );
      }
    }
    catch(err) {

    }
  };

  prefillTimer = (item) => {
    const normalizedProjectId =
      item.project_id === null || item.project_id === undefined || item.project_id === ''
        ? ''
        : Number(item.project_id);
    const normalizedClientId =
      item.client_id === null || item.client_id === undefined || item.client_id === ''
        ? ''
        : Number(item.client_id);
    let trueArr = [];
    if (item.tag_id !== null && item.tag_id !== undefined && item.tag_id !== '') {
      item.tag_id.split(',').forEach(t => trueArr.push(Number(t)));
    }
    if (this.state.isStop !== 0) this.carryAsanaTask(item, false);
    const sameProject = this.state.project_id === normalizedProjectId;
    this.setState({
      title: item.title,
      project_id: normalizedProjectId,
      project: item.project_name || item.project,
      client_id: normalizedClientId,
      client: item.client_name || item.client,
      is_billable: item.is_billable,
      tag_check_array: trueArr,
      projectAutoMatched: false,
      projectSelectionSource: normalizedProjectId !== '' ? 'manual' : '',
      autofilledProject: normalizedProjectId !== '',
    }, () => {
      if (this.asanaSource && sameProject && this.state.isStop !== 0) {
        this.syncAsanaTasks({ ...this.state, project_id: undefined, asana_task_id: "" });
      }
      const header = document.querySelector('.header');
      if (header) {
        header.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(() => {
          const descInput = document.querySelector('.header-search');
          if (descInput) descInput.focus();
        }, 350);
      }
    });
  };

  callPopOverFunctionEnter = () => {
    let element = document.getElementById("stop_btn_id");
    if(this.state.requiredFields){
      if(this.state.title === "" || this.state.project_id === "" || this.state.project_id === 0) {
        this.setState({
          showPopOver : true,
          popOverTarget : element,
        })
      }
    }
  }

  callPopOverFunctionLeave = () => {
    this.setState({
      showPopOver : false
    })
  }

  checkRequiredFields = () => {
    let element = document.getElementById("stop_btn_id");
    if(this.state.requiredFields){
      if(this.state.title === "" || this.state.project_id === "" || this.state.project_id === 0) {
        return false;
      }
      else {
        return true;
      }
    }
    else {
      return true;
    }
  }

  stopTimer = async () => {
    try{
      if(this.checkRequiredFields()){
        const snapshot = {
          title: this.state.title,
          workspace_id:
            this.state.workspace_id !== 0 &&
            this.state.workspace_id !== null &&
            this.state.workspace_id !== undefined
              ? this.state.workspace_id
              : this.props.auth.workspace_id,
          client_id: this.state.client_id,
          project_id: this.state.project_id,
          timerStart: this.state.timerStart,
          timerTime: this.state.timerTime,
          timer_id: this.state.timer_id,
          tag_check_array: this.state.tag_check_array,
          is_billable: this.state.is_billable,
          timer_start: this.state.timer_start,
        };
        clearInterval(this.timer);
        clearInterval(this.timer2);
        this.activeTimerStart = null;
        document.title = `Minutezilla`;
        let currentDate = moment().format("YYYY-MM-DD HH:mm:ss");//.unix());  
        let timeInSeconds = moment(currentDate).unix();
        //let timeInSeconds2 = 
        const config = {
          headers: {
            Authorization: `Bearer ${this.props.auth.token}`,
            "Content-Type": "application/json",
          },
        };
        let title = snapshot.title;
        let workspace_id = snapshot.workspace_id;
        let client_id = snapshot.client_id;
        let project_id = snapshot.project_id;
        let timerStart = snapshot.timerStart;
        let timerTime = snapshot.timerTime;
        let isStop = 1;
        let timer_id = snapshot.timer_id;
        let tag_check_array = snapshot.tag_check_array;
        let is_billable = snapshot.is_billable;
        let timer_start = snapshot.timer_start;
        let timer_end = timeInSeconds;
        
        const body = JSON.stringify({
          timer_id,
          workspace_id,
          title,
          client_id,
          project_id,
          timerStart,
          timer_start,
          timer_end,
          timerTime,
          isStop,
          is_billable,
          tag_check_array,
        });
        let res = await axios.put("/api/usertime/update", body, config);
        if (res.status === 200) {
          let m1 = moment();
          let dd = m1.date();
          let MM = m1.month();
          let yy = m1.year();
    
          let m = moment({ year :yy, month :MM, day :dd})._d;
          this.setState({
            timerTime: 0,
            timerStart: 0,
            isStop: 1,
            title: "",
            project: "",
            project_id: "",
            client: "",
            client_id: "",
            tag_check_array: [],
            is_billable: 0,
            manualDate : m
          });
          this.startPage();
          //this.timerList();
        }
      }
    }
    catch(err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  manualStartTimeChange = (e) => {
    clearInterval(this.backgroundTimer);
    this.setState({manualStartTime:e.target.value,isManuallyChanged:true})
  }

  checkStartTime = () => {
    if(!moment(this.state.manualStartTime,this.state.timeFormat,true).isValid()) {
      this.setState({ manualStartTime : moment().format(this.state.timeFormat)});
    }
  }

  manualEndTimeChange = (e) => {
    clearInterval(this.backgroundTimer);
    this.setState({manualEndTime:e.target.value,isManuallyChanged:true})
  }

  checkEndDate = () => {
    //console.log(moment(this.state.manualEndTime,"h:mm A",true).isValid());
    if(!moment(this.state.manualEndTime,this.state.timeFormat,true).isValid()) {
      this.setState({ manualEndTime : moment().format(this.state.timeFormat)});
    }
  }

  createManualEntry = async () => {
    if (!this.state.title || this.state.title.trim() === "") {
      this.setState({ titleError: true });
      setTimeout(() => this.setState({ titleError: false }), 3000);
      return;
    }
    try {
      if(this.checkRequiredFields()) {
        let dd = this.state.manualDate.getDate();
        let MM = this.state.manualDate.getMonth();
        let yy = this.state.manualDate.getFullYear();
        
        let startTime = `${moment({ year :yy, month :MM, day :dd}).format("YYYY-MM-DD")} ${moment(this.state.manualStartTime, "hh:mm:ss A").format("HH:mm:ss")}`;
        let endTime = `${moment({ year :yy, month :MM, day :dd}).format("YYYY-MM-DD")} ${moment(this.state.manualEndTime, "hh:mm:ss A").format("HH:mm:ss")}`;
        
        let actualStart = moment.utc(startTime).format("YYYY-MM-DD HH:mm:ss");
        let actualEnd = moment.utc(endTime).format("YYYY-MM-DD HH:mm:ss");  
        if(this.state.isTimeEntryLocked === true) {
          let checkDate = moment(actualStart).format("YYYY-MM-DD");
          if(moment(checkDate).isBefore(this.state.dbLockedDate)){
            return null;
          }
        }
        let timer_start = moment(actualStart).unix();
        let timer_end = moment(actualEnd).unix();
        let startUnix = moment.utc(actualStart).valueOf();
        let endUnix =  moment.utc(actualEnd).valueOf();
        let difference = Math.abs(startUnix-endUnix);
        const config = {
          headers: {
            Authorization: `Bearer ${this.props.auth.token}`,
            "Content-Type": "application/json",
          },
        };  
        let title = this.state.title;
        let workspace_id =
          this.state.workspace_id !== 0 &&
          this.state.workspace_id !== null &&
          this.state.workspace_id !== undefined
            ? this.state.workspace_id
            : this.props.auth.workspace_id;
  
        let client_id = this.state.client_id;
        let project_id = this.state.project_id;
        let timerStart = startUnix;
        let timerTime = difference;
        let isStop = 1;
        let tag_check_array = this.state.tag_check_array;
        let is_billable = this.state.is_billable;
        let crdate = actualStart;
        let modified_date = actualEnd;
  
        const body = JSON.stringify({
          workspace_id,
          title,
          client_id,
          project_id,
          timerStart,
          timer_start,
          timer_end,
          timerTime,
          isStop,
          is_billable,
          tag_check_array,
          crdate,
          modified_date
        });
      let res = await axios.post("/api/usertime/manual_entry", body, config);
        if(res.status === 200) {
          this.setState({
            title: "",
            project: "",
            project_id : "",
            client: "",
            tag_check_array: [],
            is_billable: 0,
            manualStartTime : moment().format(this.state.timeFormat),
            manualEndTime : moment().format(this.state.timeFormat),
            isManuallyChanged:false,
            isManual : false
          });
          this.runTimer();
          this.startPage();
          //this.timerList();
        }
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  } 

  checkRunningStartTime = () => {
    if(!moment(this.state.runningTimerStart,this.state.timeFormat,true).isValid()) {
      this.setState({runningTimerStart : moment.unix(this.state.timer_start).format(this.state.timeFormat)});
    }
    this.makeChangeInRunningTimer()
  }

  callRunningCalendarTImer = (hours,minutes,seconds) => {
    if(this.state.isStop === 0) {
      this.setState({displayRunningTimerCalendar : true,runningDuration : `${hours}:${minutes}:${seconds}`}) 
    }
  }

  changeRunningTimerStart = (e) => {
    this.setState({runningTimerStart : e.target.value})
  }

  makeChangeInRunningTimer = async (item) => {
    try {
      let startTime, endTime;
      if(item) {
        let dd = item.getDate();
        let MM = item.getMonth();
        let yy = item.getFullYear();
        startTime = `${moment({ year :yy, month :MM, day :dd}).format("YYYY-MM-DD")} ${moment(this.state.runningTimerStart, "hh:mm:ss A").format("HH:mm:ss")}`;
        endTime = `${moment({ year :yy, month :MM, day :dd}).format("YYYY-MM-DD")} ${moment(this.state.runningTimerStop, "hh:mm:ss A").format("HH:mm:ss")}`;
      }
      else {
        let dd = this.state.manualDate.getDate();
        let MM = this.state.manualDate.getMonth();
        let yy = this.state.manualDate.getFullYear();

        startTime = `${moment({ year :yy, month :MM, day :dd}).format("YYYY-MM-DD")} ${moment(this.state.runningTimerStart, "hh:mm:ss A").format("HH:mm:ss")}`;
        endTime = `${moment({ year :yy, month :MM, day :dd}).format("YYYY-MM-DD")} ${moment(this.state.runningTimerStop, "hh:mm:ss A").format("HH:mm:ss")}`;
      }

      let newStartTime ;

      let time = moment().valueOf();
      let time2 = moment(startTime).valueOf();
      if(time2 > time) {
        let comingdate = moment(endTime).date();
        let currentdate = moment().date();
        let d = comingdate-currentdate;
        d = d+ 1;
        newStartTime = moment(startTime).subtract(d,"days");

        //console.log(newStartTime,comingdate,currentdate,d)
      }
      else {
        //console.log(startTime)
        newStartTime = startTime;
      }
      //console.log(startTime,newStartTime,time2>time)
      if(this.state.isTimeEntryLocked === true) {
        let checkDate = moment(newStartTime).format("YYYY-MM-DD");
        if(moment(checkDate).isBefore(this.state.dbLockedDate)){
          return null;
        }
      }
      let timer_start = moment(newStartTime).unix();
      let timer_end = moment(endTime).unix();
      let startUnix = moment(newStartTime).valueOf();
      let endUnix =  moment(endTime).valueOf();
      let difference = Math.abs(startUnix-endUnix);
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };  
      let timer_id = this.state.timer_id;
      let title = this.state.title;
      let workspace_id =
        this.state.workspace_id !== 0 &&
        this.state.workspace_id !== null &&
        this.state.workspace_id !== undefined
          ? this.state.workspace_id
          : this.props.auth.workspace_id;

      let client_id = this.state.client_id;
      let project_id = this.state.project_id;
      let timerStart = startUnix;
      let timerTime = difference;
      let isStop = 0;
      let tag_check_array = this.state.tag_check_array;
      let is_billable = this.state.is_billable;
      let crdate = startTime;
      let modified_date = endTime;
      

      const body = JSON.stringify({
        timer_id,
        workspace_id,
        title,
        client_id,
        project_id,
        timerStart,
        timer_start,
        timer_end,
        timerTime,
        isStop,
        is_billable,
        tag_check_array,
        crdate,
        modified_date
      });
    let res = await axios.put("/api/usertime/edit_manually", body, config);
      if(res.status === 200) {
        this.setState({
          /*title: "",
          project: "",
          client: "",
          tag_check_array: [],
          is_billable: 0,*/
          manualStartTime : moment().format(this.state.timeFormat),
          manualEndTime : moment().format(this.state.timeFormat),
          isManuallyChanged:false
        });
        this.runTimer();
        this.startPage()
      }
    
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }  }
    
    handleDurationChange = (e) => {
      this.setState({runningDuration : e.target.value});
    }

    autoFormatDuration = (val) => {
      if (!val || !val.trim()) return null;
      val = val.trim();
      // Full H:MM:SS or HH:MM:SS — just zero-pad
      const full = val.match(/^(\d{1,3}):([0-5]?\d):([0-5]?\d)$/);
      if (full) {
        return `${full[1].padStart(2,'0')}:${full[2].padStart(2,'0')}:${full[3].padStart(2,'0')}`;
      }
      // H:MM or HH:MM — append :00
      const hhmm = val.match(/^(\d{1,3}):([0-5]?\d)$/);
      if (hhmm) {
        return `${hhmm[1].padStart(2,'0')}:${hhmm[2].padStart(2,'0')}:00`;
      }
      // Plain integer ≤ 23 → treat as hours
      const plain = val.match(/^(\d{1,2})$/);
      if (plain && parseInt(plain[1]) <= 23) {
        return `${plain[1].padStart(2,'0')}:00:00`;
      }
      return null;
    }

    adjustDurationByMinutes = (deltaMinutes) => {
      const dur = this.state.runningDuration || '00:00:00';
      const parts = dur.split(':');
      let totalSeconds = (parseInt(parts[0]) || 0) * 3600
        + (parseInt(parts[1]) || 0) * 60
        + (parseInt(parts[2]) || 0);
      totalSeconds = Math.max(60, totalSeconds + deltaMinutes * 60);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      const fmt = n => String(n).padStart(2, '0');
      this.setState({ runningDuration: `${fmt(h)}:${fmt(m)}:${fmt(s)}`, durationFieldError: false, durationFlash: true });
      // Debounced auto-submit — allows stacking multiple quick clicks before committing
      clearTimeout(this._durationSubmitTimer);
      this._durationSubmitTimer = setTimeout(() => this.submitDuration(), 1200);
    }

    changeDateInCalendar = (item) => {
      this.setState({manualDate : item});
      this.makeChangeInRunningTimer(item);
    }

    submitDuration = async () => {
      try{
        let endTime = moment().format("YYYY-MM-DD HH:mm:ss");

        // Try to auto-format partial input (e.g. "1:30" → "01:30:00", "2" → "02:00:00")
        let dur = this.state.runningDuration;
        const formatted = this.autoFormatDuration(dur);
        if (formatted && formatted !== dur) {
          dur = formatted;
          this.setState({ runningDuration: formatted });
        }

        if(dur.match(/([0-9][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]/g)
          && dur !== "00:00:00") {

            this.setState({durationFieldError : false})
          let arrayOfTime = dur.split(':');
          let hours = arrayOfTime[0];
          let minutes = arrayOfTime[1];
          let seconds = arrayOfTime[2];

          let startTime = moment().subtract(hours,"hours").subtract(minutes,"minutes").subtract(seconds,"seconds").format("YYYY-MM-DD HH:mm:ss");
          //console.log(startTime,endTime)
          let actualStart = moment(startTime).format("YYYY-MM-DD HH:mm:ss");
          let actualEnd = moment(endTime).format("YYYY-MM-DD HH:mm:ss");
          //console.log(actualStart,actualEnd);
          if(this.state.isTimeEntryLocked === true) {
            let checkDate = moment(actualStart).format("YYYY-MM-DD");
            console.log(this.state.dbLockedDate,checkDate);
            if(moment(checkDate).isBefore(this.state.dbLockedDate)){
              console.log("out of here")
              return null;
            }
          }
          let timer_start = moment(actualStart).unix();
          let timer_end = moment(actualEnd).unix();
          let startUnix = moment(actualStart).valueOf();
          let endUnix =  moment(actualEnd).valueOf();
          let difference = Math.abs(startUnix-endUnix);
          const config = {
            headers: {
              Authorization: `Bearer ${this.props.auth.token}`,
              "Content-Type": "application/json",
            },
          };  
          let title = this.state.title;
          let workspace_id =
          this.state.workspace_id !== 0 &&
          this.state.workspace_id !== null &&
          this.state.workspace_id !== undefined
              ? this.state.workspace_id
              : this.props.auth.workspace_id;
    
          let client_id = this.state.client_id;
          let project_id = this.state.project_id;
          let timerStart = startUnix;
          let timerTime = difference;
          let isStop = 0;
          let tag_id = this.state.tag_id;
          let is_billable = this.state.is_billable;
          let timer_id = this.state.timer_id;
          
    
          const body = JSON.stringify({
            timer_id,
            workspace_id,
            title,
            client_id,
            project_id,
            timerStart,
            timer_start,
            timer_end,
            timerTime,
            isStop,
            is_billable,
            tag_id
          });
          //console.log(body);
        let res = await axios.put("/api/usertime/edit_manually", body, config);
          if(res.status === 200) {
            this.startPage();
          }
        }
        else {
          this.setState({durationFieldError : true})
          //this.startPage();
        }  
      } 
      catch(err) {
        console.log(err);
        if (err.response) {
          console.log(err.response);
        }
      }
    }

  fetchWeeklyChartData = async () => {
    try {
      const start_date   = moment().subtract(6, 'days').startOf('day').unix();
      const workspace_id = this.props.auth.workspace_id;
      const res = await axios.post(
        '/api/usertime/chart',
        { start_date, workspace_id },
        { headers: { Authorization: `Bearer ${this.props.auth.token}` } }
      );
      if (res.status === 200) {
        this.setState({ chartData7d: res.data.results || [] });
      }
    } catch (err) {
      console.error('fetchWeeklyChartData error:', err);
    }
  };

  projectList = async (wid, is_w_admin, searchTermOverride) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id;
      if (wid !== undefined && wid !== null && wid !== "") {
        workspace_id = wid;
      } else if (
        this.state.workspace_id !== 0 &&
        this.state.workspace_id !== null &&
        this.state.workspace_id !== undefined
      ) {
        workspace_id = this.state.workspace_id;
      } else {
        workspace_id = this.props.auth.workspace_id;
      }
      let is_workspace_admin;
      if(is_w_admin === 0 || is_w_admin === 1) {
        is_workspace_admin = is_w_admin;
      }
      else {
        is_workspace_admin = this.props.auth.is_workspace_admin;
      }
      let searchTerm =
        searchTermOverride !== undefined ? searchTermOverride : this.state.searchTerm;
      let is_archived = 0;
      const body = JSON.stringify({
        workspace_id,
        is_workspace_admin,
        is_archived,
        searchTerm,
      });
      let res = await axios.post("/api/project/search", body, config);
      if(res.status === 200) {
        let tempProjectArray = [];
        tempProjectArray.push({
          client_id: 0,
          client_name: null,
          id: 0,
          project_color: "",
          project_name: "",
          workspace_id : this.state.workspace_id,
          isbillable : 0
        })

        res.data.results.map(item => {
          const clientDisplayName = item.client_display_name || item.client_company_name || item.client_name;
          tempProjectArray.push({
              client_id: item.client_id,
              client_name: item.client_name || null,
              client_display_name: clientDisplayName,
              id: item.id,
              is_archived: item.is_archived,
              project_color: item.project_color,
              project_name: item.project_name,
              project_label: item.project_name,
              user_id: item.user_id,
              workspace_id: item.workspace_id,
              isbillable : item.isbillable
          })
        })

        let mixArray = tempProjectArray.reduce(
          (h, obj) =>
            Object.assign(h, {
              [obj.client_display_name ?? obj.client_name]: (h[obj.client_display_name ?? obj.client_name] || []).concat(obj),
            }),
          {}
        );
        const shouldRefreshCatalog =
          searchTerm.trim() === "" || Object.keys(this.state.projectCatalog || {}).length === 0;
        this.setState({
          projectArray: mixArray,
          ...(shouldRefreshCatalog ? { projectCatalog: mixArray } : {}),
        }, () => {
          if (this.state.title) {
            this.syncProjectFromTitle(this.state.title);
          }
        });
    }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  clientList = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = this.props.auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post("/api/client/list", body, config);
      this.setState({ clientArray: res.data.results });
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  handleTagterm = (e) => {
    this.setState({tagterm : e.target.value})
  }

  tagList = async (wid) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id;
      if (wid !== undefined && wid !== null && wid !== "") {
        workspace_id = wid;
      } else if (
        this.state.workspace_id !== 0 &&
        this.state.workspace_id !== null &&
        this.state.workspace_id !== undefined
      ) {
        workspace_id = this.state.workspace_id;
      } else {
        workspace_id = this.props.auth.workspace_id;
      }
      let tagTerm = this.state.tagterm !== "" && this.state.tagterm !== undefined? this.state.tagterm : "";
      const body = JSON.stringify({ workspace_id,tagTerm });
      let res = await axios.post("/api/tag/list", body, config);
      this.setState({ tagArray: res.data.results });
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  getWorkspaceInfo = async (wid) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id;
      if (wid !== undefined && wid !== null && wid !== "") {
        workspace_id = wid;
      } else if (
        this.state.workspace_id !== 0 &&
        this.state.workspace_id !== null &&
        this.state.workspace_id !== undefined
      ) {
        workspace_id = this.state.workspace_id;
      } else {
        workspace_id = this.props.auth.workspace_id;
      }
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post(
        "/api/workspace/listbyworkspaceid",
        body,
        config
      );
      if (res.status === 200) {
        res.data.results.map((item) => {
          if (Number(item.id) === Number(workspace_id)) {
            let m;
            if(item.is_time_entry_locked  === 1) {
              let arr = item.locked_date.split('-');
              let dd = arr[0];
              let MM = arr[1];
              let yy = arr[2];
              m = moment({year : yy, month : MM, date : dd}).format("YYYY-MM-DD");
            }
            this.setState({
              workspace_id: item.id,
              workspace_title: item.title,
              requiredFields : item.is_required_fields === 1 ?true : false,
              isTimeEntryLocked : item.is_time_entry_locked  === 1?true:false,
              dbLockedDate : item.is_time_entry_locked  === 1?m:""
            });
          }
        });
        this.setState({ workspaceArray: res.data.results });
      }
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  selectWorkspace = async (id) => {
    this.setState({ workspace_id: id });
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post("/api/workspace/get", body, config);
      if (res.status === 200) {
        let is_w_admin = res.data.is_workspace_admin;
        let wid = res.data.workspace_id;
        this.getWorkspaceInfo(wid);
        this.projectList(wid, is_w_admin);
        this.tagList(wid);
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  hideTagDropDown = () => {
    this.setState({ tagOpen: false });
  };

  handleCheck = (item) => {
    if(this.state.isStop === 0) {
      this.changeTag(item,this.state.timer_id)
    }
    let newArr = [];
    //newArr = [item];
    if (!this.state.tag_check_array.includes(item)) {
      newArr = [item];
    } else {
      newArr = [];
    }
    this.setState({ tag_check_array: newArr });
  };

  projectClick = (item) => {
    if(this.state.isStop === 0) {
      this.changeProject(item,this.state.timer_id);
      let bb = item.isbillable === 1?0:1;
      this.changeBillable(this.state.timer_id,bb);
      this.setState({
        projectOpen: false,
        showAllProjects: false,
        client: item.client_display_name || item.client_name || item.client || "",
        client_id: item.client_id,
        project: item.project_label || item.project_name || item.project || "",
        project_id: item.id,
        is_billable : item.isbillable === 1?1:0,
        projectAutoMatched : false,
        projectSelectionSource : "manual",
      });
    }
    else {
      this.setState({
        projectOpen: false,
        showAllProjects: false,
        client: item.client_display_name || item.client_name || item.client || "",
        client_id: item.client_id,
        project: item.project_label || item.project_name || item.project || "",
        project_id: item.id,
        is_billable : item.isbillable === 1?1:0,
        projectAutoMatched : false,
        projectSelectionSource : "manual",
      }); 
    }
  };

  changeProject = async (proj, id) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = proj.workspace_id;
      let timer_id = id;
      let project_id = proj.id;
      let client_id = proj.client_id;
      let tag, tagcolor;

      const body = JSON.stringify({
        workspace_id,
        timer_id,
        project_id,
        client_id,
      });
      let res = await axios.put("/api/usertime/update_project", body, config);
      if (res.status === 200) {
        let bb = proj.isbillable === 1?0:1;
        this.changeBillable(timer_id,bb);
        this.startPage();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  changeTag = async (tag_id, timer_id) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };

      const body = JSON.stringify({ timer_id, tag_id });
      let res = await axios.put("/api/usertime/update_tag", body, config);
      if (res.status === 200) {
        this.startPage();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  changeBillable = async (timer_id, billable) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };

      let is_billable = billable === 1 ? 0 : 1;
      const body = JSON.stringify({ timer_id, is_billable });
      let res = await axios.put("/api/usertime/update_billable", body, config);
      if (res.status === 200) {
        this.startPage();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  changeTitle = async (timer_id, title) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${this.props.auth.token}`,
          "Content-Type": "application/json",
        },
      };
      if (title === "" || title === undefined) {
        this.startPage();
      } else {
        const body = JSON.stringify({
          timer_id,
          title,
          workspace_id: this.props.auth.workspace_id,
        });
        let res = await axios.put("/api/usertime/update_title", body, config);
        if (res.status === 200) {
          this.checkTitle(timer_id)
          this.startPage();
        }
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  checkTitle = async (timer_id) => {  /* function to set default project tag and  billable by 
    taking entered description */
    try{
    let filteredArray = [];
    if(timer_id === this.state.timer_id) {
      let arr;
      if(this.state.timeList2.length > 0) {
        arr = this.state.timeList2.slice(0,10);
      }
      else {
        arr = this.state.timeList2;
      }
      let i = 0;
      arr.map(item => {
        if(item.title == this.state.title) {
          if(timer_id == item.timer_id) {
            return false;
          }
          else {
            i++;
            filteredArray.push(item);
          }
        }
      })
      if(filteredArray.length > 0) {
        const config = {
          headers: {
            Authorization: `Bearer ${this.props.auth.token}`,
            "Content-Type": "application/json",
          },
        };
        let project_id = filteredArray[0].project_id !== null && 
          filteredArray[0].project_id !== undefined ? filteredArray[0].project_id:0;
        let client_id = filteredArray[0].client_id !== null && 
          filteredArray[0].client_id !== undefined ? filteredArray[0].client_id:0;
        let workspace_id = filteredArray[0].workspace_id;
        let tag_id = filteredArray[0].tag_id;
        let is_billable = filteredArray[0].is_billable === 1 ? 1 : 0;

        const body = JSON.stringify({ 
          timer_id, 
          project_id, 
          client_id, 
          workspace_id, 
          tag_id, 
          is_billable 
        });
        let res = await axios.put("/api/usertime/update_parts", body, config);
        if(res.status === 200) {
          this.startPage()
        }
      }
    }
    }
    catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  }

  deleteEntry = async () => {
    try {
        let timer_id = this.state.timer_id;
        const config = {
            headers : {
                Authorization : `Bearer ${this.props.auth.token}`,
                "Content-type" : "application/json"
            },
        };

        const body = JSON.stringify({ timer_id });
        let res = await axios.post("/api/usertime/delete_start", body, config);
        if(res.status === 200) {
          let m1 = moment();
          let dd = m1.date();
          let MM = m1.month();
          let yy = m1.year();
          let m = moment({ year :yy, month :MM, day :dd})._d;
          this.setState({
            title: "",
            project: "",
            project_id: "",
            client: "",
            client_id: "",
            tag_check_array: [],
            is_billable: 0,
            timerTime: 0, timerStart: 0, isStop: 1,
            timer_start : 0, timer_end : 0,
            manualDate : m
          }, async () => {
            await this.startPage();
            document.title = `Minutezilla`;
          });
            
        }
    }
    catch(err) {
      console.log(err)
    }
  }

  reload = () => {
    this.suppressTimerSyncUntil = Date.now() + 2000;
    return this.startPage(true);
  }

  hanldeKeydown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      if (this.state.isStop === 1) {
        let filteredArray = [];
          let arr;
          if(this.state.timeList2.length > 0) {
            arr = this.state.timeList2.slice(0,10);
          }
          else {
            arr = this.state.timeList2;
          }
          let i = 0;
          arr.map(item => {
            if(item.title == this.state.title) {
                i++;
                filteredArray.push(item);
            }
          })
          if(filteredArray.length > 0) {
            let project = filteredArray[0].project_name ?filteredArray[0].project_name:"";
            let client = filteredArray[0].client_name ?filteredArray[0].client_name:"";
            let project_color = filteredArray[0].project_color ?filteredArray[0].project_color:"";
            let project_id = filteredArray[0].project_id !== null && 
              filteredArray[0].project_id !== undefined ? filteredArray[0].project_id:0;
            let client_id = filteredArray[0].client_id !== null && 
              filteredArray[0].client_id !== undefined ? filteredArray[0].client_id:0;
            let workspace_id = filteredArray[0].workspace_id;
            let tag_id = filteredArray[0].tag_id === undefined || 
                        filteredArray[0].tag_id === null || 
                        filteredArray[0].tag_id === "" ?[]:[parseInt(filteredArray[0].tag_id)];
            let is_billable = filteredArray[0].is_billable === 1 ? 1 : 0;

            this.setState({
              project: project,
              project_id: project_id,
              client: client,
              client_id: client_id,
              tag_check_array: tag_id,
              is_billable: is_billable,
              workspace_id : workspace_id,
              project_color : project_color
            })
          }
        this.startTimer();
      }
    }
  };

  callTitleChangeFunction = (timer_id,title) => {
    if(this.state.isStop === 0) {
      this.changeTitle(timer_id,title)
    }
  }

  callBillableChange = () => {
    if(this.state.isStop === 0) {
      this.changeBillable(this.state.timer_id,this.state.is_billable)
    }
  }

  loadMoreItems = async () => {
    try {
      const filled = await this.loadRecentEntriesUntilFilled({
        startOffset: this.state.offset,
        minimumVisibleEntries: 15,
        groupSimilar: this.state.is_group_similar,
      });
      const conc = this.state.timeList2.concat(filled.rawResults);
      const final_result = await this.groupByEntry(conc, this.state.is_group_similar);
      this.setState({
        timeList: final_result,
        offset: filled.offset,
        loading: false,
        spinner: false,
        timeList2: conc,
      });
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  }
  handleProjectModalShow = () => {
    this.clientList();
    this.setState({projectModalShow:true})
  };

  hideModal = () => {
    this.setState({projectModalShow:false})
  };

  reloadFunction = async (item) => {
    await this.projectList();
    await this.clientList();
    this.projectClick(item);
    //this.reload();
  };

  setProject = (item) => {
    this.setState({
      projectOpen: false,
      client: item.client_display_name || item.client_name || item.client || "",
      client_id: item.client_id,
      project: item.project_label || item.project_name || item.project || "",
      project_id: item.id,
      projectAutoMatched: false,
      projectSelectionSource: "manual",
    }); 
  }

  getWeeklyChartData = () => {
    const { chartData7d } = this.state;
    const labels = [];
    const data   = [];
    for (let i = 6; i >= 0; i--) {
      const d = moment().subtract(i, 'days');
      labels.push(d.toDate().toLocaleDateString(getLocale(), { weekday: 'short' }));
      let totalMs = 0;
      if (chartData7d) {
        chartData7d.forEach(entry => {
          if (moment.unix(entry.timer_start).format('YYYY-MM-DD') === d.format('YYYY-MM-DD')) {
            totalMs += parseInt(entry.timerTime || 0);
          }
        });
      }
      data.push(parseFloat((totalMs / 3600000).toFixed(2)));
    }
    return { labels, data };
  }

  getDashboardStats = () => {
    const { timeList, timeList2, isStop, timerTime } = this.state;
    const todayKey = moment().format("ddd MMM DD YYYY");

    const flat = timeList2 || [];

    let todayMs = isStop === 0 ? timerTime : 0;
    flat.forEach(entry => {
      if (moment(entry.timer_start, 'X').format("ddd MMM DD YYYY") === todayKey) {
        todayMs += parseInt(entry.timerTime || 0);
      }
    });

    let weekMs = isStop === 0 ? timerTime : 0;
    const weekStart = moment().startOf('isoWeek');
    flat.forEach(entry => {
      const d = moment(entry.timer_start, 'X');
      if (d.isValid() && d.valueOf() >= weekStart.valueOf()) {
        weekMs += parseInt(entry.timerTime || 0);
      }
    });

    const projectSet = new Set();
    flat.forEach(entry => {
      if (entry.project_id && entry.project_id !== 0) {
        projectSet.add(entry.project_id);
      }
    });

    const todayEntries = flat.filter(e =>
      moment(e.timer_start, 'X').format("ddd MMM DD YYYY") === todayKey
    ).length;

    return { todayMs, weekMs, projectCount: projectSet.size, todayEntries };
  }

  formatDuration = (ms) => {
    if (!ms || ms <= 0) return "0h 00m";
    const totalSeconds = Math.floor(ms / 1000);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    if (h === 0) return `${m}m`;
    return `${h}h ${String(m).padStart(2, '0')}m`;
  }

  render() {
    let seconds = 0;
    let minutes = 0;
    let hours = 0;
    let duration;
    if (//this.state.timerTime === 0 ||
       this.state.isStop === 1) {
      seconds = "00";
      minutes = "00";
      hours = "00";
    } else {
      const timerTime = this.state.timerTime;
      seconds = (timerTime / 1000).toFixed();
      // 2- Extract hours:
      hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
      if(parseInt(hours/10) === 0) {
        hours = ("0" + hours);
      }
      seconds = seconds % 3600; // seconds remaining after extracting hours
      // 3- Extract minutes:
      minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
      // 4- Keep only seconds not extracted to minutes:
      seconds = ("0" + (seconds % 60)).slice(-2);
      //return `${hours}:${minutes}:${seconds}`;
      if(this.state.displayRunningTimerCalendar === false) {
       duration = `${hours}:${minutes}:${seconds}`
      }
    }

    return (
      <div>
        <Sidebar />
        <div className='header'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='topbar-timer-header-contain'>
                <div style={{ position: 'relative' }} className={`what-are-you-woring${this.state.autofilled ? ' what-are-you-woring--autofilled' : ''}`}
                  onAnimationEnd={(e) => { if (e.animationName === 'autofill-flash') this.setState({ autofilled: false }); }}>
                  <form onSubmit={() => this.handleSubmit()}>
                    <input
                      type='text'
                      className={`header-search${this.state.titleError ? ' header-search--error' : ''}${this.state.asana_task_id ? ' header-search--asana' : ''}`}
                      placeholder={
                        this.state.titleError
                          ? tr("Description is required!")
                          : this.state.isManual
                          ? tr("What have you done?")
                          : tr("What are you working on?")
                      }
                      name=''
                      value={this.state.title}
                      onChange={(e) => { this.setState({ titleError: false, autofilled: false, asanaSuggestOpen: true, asanaActive: -1 }); this.titleOnChange(e); }}
                      onPaste={(e) => this.titleOnPaste(e)}
                      onFocus={() => this.setState({ asanaSuggestOpen: true, asanaActive: -1 })}
                      onBlur={()=>{ this.setState({ asanaSuggestOpen: false }); this.callTitleChangeFunction(this.state.timer_id,this.state.title); }}
                      onKeyDown={(e) => { if (!this.asanaSuggestKeydown(e)) this.hanldeKeydown(e); }}
                    />
                    {this.state.asana_task_id && (
                      <span className='asana-task-badge' title={tr("Linked to an Asana task")}>
                        Asana
                        <button type='button' aria-label={tr("Remove Asana task link")} onMouseDown={(e) => e.preventDefault()} onClick={() => this.selectAsanaTask('')}>×</button>
                      </span>
                    )}
                    {this.renderAsanaSuggestions()}
                  </form>
                </div>
                <div
                  className={`nav nav-pills nav-stacked header-folder${this.state.autofilledProject ? ' autofill-flash-el' : ''}`}
                  ref={this.wrapperRef}
                  onAnimationEnd={(e) => { if (e.animationName === 'autofill-flash') this.setState({ autofilledProject: false }); }}
                >
                  <div
                    className={
                      this.state.projectOpen ? "dropdown show" : "dropdown"
                    }
                  >
                    <div
                      className=' dropdown-toggle'
                      data-tour='dashboard-project-picker'
                      data-toggle='dropdown'
                      aria-expanded='true'
                      onClick={() => {
                        this.setState({ projectOpen: true, showAllProjects: false });
                      }}
                    >
                      {this.state.project !== "" &&
                      this.state.project !== null &&
                      this.state.project !== undefined ? (
                        <span className='topbar-project-chip'>
                          <span
                            className='topbar-project-dot'
                            style={{ background: this.state.project_color || '#a0aec0' }}
                          ></span>
                          <span className='topbar-project-name'>{this.state.project}</span>
                        </span>
                      ) : (
                        <span className='topbar-folder-empty'>
                          <svg xmlns='http://www.w3.org/2000/svg' width='15' height='12'>
                            <path
                              fill='currentColor'
                              fillRule='evenodd'
                              d='M0 6h16v4.994A2.001 2.001 0 0 1 14.006 13H1.994A1.993 1.993 0 0 1 0 10.994V6zm0-4a2 2 0 0 1 2.004-2h3.05c1.107 0 2.004.895 2.004 2h6.935C15.102 2 16 2.895 16 4H0V2z'
                            />
                          </svg>
                          <span>{tr("Project")}</span>
                        </span>
                      )}
                    </div>

                    {this.state.projectOpen && (() => {
                      const PROJECT_LIMIT = 15;
                      const allEntries = Object.entries(this.state.projectArray);
                      // Count total projects across all groups
                      const totalCount = allEntries.reduce((sum, [, data]) => sum + Object.values(data).length, 0);
                      const showAll = this.state.showAllProjects;

                      // Build visible groups respecting limit
                      let rendered = 0;
                      const visibleGroups = [];
                      for (const [client_name, data] of allEntries) {
                        const projects = Object.values(data);
                        if (!showAll && rendered >= PROJECT_LIMIT) break;
                        let slice = projects;
                        if (!showAll && rendered + projects.length > PROJECT_LIMIT) {
                          slice = projects.slice(0, PROJECT_LIMIT - rendered);
                        }
                        if (slice.length > 0) {
                          visibleGroups.push({ client_name, projects: slice });
                          rendered += slice.length;
                        }
                      }

                      return (
                        <div
                          className='dropdown-menu filter-by-button-dropdown-wrap show'
                          x-placement='bottom-start'
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: "0px",
                            marginTop: "6px",
                          }}
                        >
                          <div className='pd-container'>

                            {/* Search */}
                            <div className='pd-search-wrap'>
                              <svg className='pd-search-icon' xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'>
                                <path fill='currentColor' d='M13.9,12.8L10.2,9c0.7-0.9,1.2-2.2,1.2-3.4C11.3,2.5,8.8,0,5.7,0C2.6,0,0,2.6,0,5.7c0,3.2,2.5,5.7,5.7,5.7 c1.2,0,2.3-0.4,3.4-1.2l3.6,3.6C12.8,14,12.9,14,13,14s0.1,0,0.2-0.1l0.8-0.8C14,13.1,14,12.9,13.9,12.8z M9.8,5.7 c0,2.2-1.8,4-4.1,4s-4.1-1.8-4.1-4c0-2.2,1.9-4.1,4.1-4.1C8,1.7,9.8,3.5,9.8,5.7z'/>
                              </svg>
                              <input
                                type='text'
                                tabIndex='4'
                                placeholder={tr("Search projects...")}
                                className='pd-search-input'
                                data-tour='dashboard-project-search'
                                value={this.state.searchTerm}
                                onChange={this.searchTermOnChange}
                              />
                            </div>

                            {/* Workspace row */}
                            {this.state.workspaceArray.length > 1 && (
                              <div className='pd-workspace-row'>
                                <span className='pd-workspace-label'>{tr("Workspace")}</span>
                                <div className='pd-workspace-select dropdown'>
                                  <div className='pd-workspace-toggle dropdown-toggle' data-toggle='dropdown'>
                                    <span>{this.state.workspace_title}</span>
                                    <i className='fa fa-angle-down' aria-hidden='true'></i>
                                  </div>
                                  <div className='dropdown-menu' style={{ top: "calc(100% + 4px)", left: 0, minWidth: "160px" }}>
                                    <ul className='popdropdown-inner-drop-cont' style={{ margin: 0, padding: "4px 0", listStyle: "none" }}>
                                      {this.state.workspaceArray.map((item, index) => (
                                        <li
                                          key={index}
                                          className={`pd-ws-item${item.title === this.state.workspace_title ? " pd-ws-item--active" : ""}`}
                                          onClick={() => {
                                            this.setState({ workspace_title: item.title });
                                            this.selectWorkspace(item.id);
                                          }}
                                        >
                                          {item.title}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Project list */}
                            <div className='pd-list-scroll'>
                              {visibleGroups.length === 0 ? (
                                <div className='pd-empty'>{tr("No projects found")}</div>
                              ) : (
                                visibleGroups.map(({ client_name, projects }, gi) => (
                                  <div className='pd-group' key={gi}>
                                    <div className='pd-group-header'>
                                      {client_name === "null" || client_name === null ? tr("No Client") : client_name}
                                    </div>
                                    {projects.map((item, pi) => (
                                      <div
                                        className={`pd-item${item.id === this.state.project_id ? " pd-item--active" : ""}`}
                                        key={pi}
                                        onClick={() => this.projectClick(item)}
                                      >
                                        <span
                                          className='pd-item-dot'
                                          style={{ background: item.project_color || "#a0aec0" }}
                                        />
                                        <span className='pd-item-name'>
                                          {item.id === 0 ? tr("No Project") : item.project_name}
                                        </span>
                                        {item.id === this.state.project_id && (
                                          <span className='pd-item-check'>
                                            <svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
                                              <path d='M2 6l3 3 5-5' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'/>
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                ))
                              )}

                              {/* Show more / Show less */}
                              {totalCount > PROJECT_LIMIT && (
                                <button
                                  className='pd-show-more'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({ showAllProjects: !showAll });
                                  }}
                                >
                                  {showAll
                                    ? `Show less`
                                    : `Show ${totalCount - PROJECT_LIMIT} more project${totalCount - PROJECT_LIMIT !== 1 ? "s" : ""}`}
                                </button>
                              )}
                            </div>

                            {/* Footer: Create Project */}
                            <div className='pd-footer'>
                              <button
                                className='pd-create-btn'
                                onClick={() => this.handleProjectModalShow()}
                              >
                                <svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
                                  <path d='M6 1v10M1 6h10' stroke='currentColor' strokeWidth='2' strokeLinecap='round'/>
                                </svg>{tr("New Project")} </button>
                            </div>

                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>
                <div
                  ref={this.tagDropdownRef}
                  className={`nav nav-pills nav-stacked header-tag-icon${this.state.autofilledTags ? ' autofill-flash-el' : ''}`}
                  onClick={() => {
                    this.setState({ tagOpen: !this.state.tagOpen });
                  }}
                  onAnimationEnd={(e) => { if (e.animationName === 'autofill-flash') this.setState({ autofilledTags: false }); }}
                >
                  <div
                    className={this.state.tagOpen ? "dropdown show" : "dropdown"}
                  >
                    <div
                      className='dropdown-toggle'
                      data-toggle='dropdown'
                      href='javascript:void(0)'
                      aria-expanded='false'
                    >
                      <span className={this.state.tag_check_array && this.state.tag_check_array.length > 0 ? 'tag-inner tag-inner--on' : 'tag-inner'}>#</span>
                    </div>
                    <div
                      className={this.state.tagOpen ? "dropdown-menu filter-by-button-dropdown-wrap show" : "dropdown-menu filter-by-button-dropdown-wrap"}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: "0px",
                        marginTop: "6px",
                      }}
                    >
                      <div className='td-container'>
                        <div className='td-search-wrap'>
                          <svg className='td-search-icon' xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'>
                            <path fill='currentColor' d='M13.9,12.8L10.2,9c0.7-0.9,1.2-2.2,1.2-3.4C11.3,2.5,8.8,0,5.7,0C2.6,0,0,2.6,0,5.7c0,3.2,2.5,5.7,5.7,5.7 c1.2,0,2.3-0.4,3.4-1.2l3.6,3.6C12.8,14,12.9,14,13,14s0.1,0,0.2-0.1l0.8-0.8C14,13.1,14,12.9,13.9,12.8z M9.8,5.7 c0,2.2-1.8,4-4.1,4s-4.1-1.8-4.1-4c0-2.2,1.9-4.1,4.1-4.1C8,1.7,9.8,3.5,9.8,5.7z'/>
                          </svg>
                          <input
                            type='text'
                            placeholder={tr("Search tags…")}
                            className='td-search-input'
                            value={this.state.tagterm}
                            onChange={this.handleTagterm}
                            onKeyUp={this.tagList}
                            onKeyDown={(e) => { if (e.key === 'Escape') { this.setState({ tagOpen: false }); } }}
                          />
                        </div>
                        <div className='td-list-scroll'>
                          {(() => {
                            const filtered = this.state.tagterm
                              ? this.state.tagArray.filter(t => t.tag_title.includes(this.state.tagterm))
                              : this.state.tagArray;
                            if (filtered.length === 0) {
                              return <div className='td-empty'>{tr("No tags found")}</div>;
                            }
                            return filtered.map((item, index) => (
                              <div
                                className={`td-item${this.state.tag_check_array.includes(item.id) ? ' td-item--active' : ''}`}
                                key={index}
                                onClick={() => { this.handleCheck(item.id); this.setState({ tagOpen: false }); }}
                              >
                                <span className='td-item-dot' style={{ background: item.tagcolor || '#a0aec0' }} />
                                <span className='td-item-name'>{item.tag_title}</span>
                                {this.state.tag_check_array.includes(item.id) && (
                                  <span className='td-item-check'>
                                    <svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
                                      <path d='M2 6l3 3 5-5' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'/>
                                    </svg>
                                  </span>
                                )}
                              </div>
                            ));
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`nav nav-pills nav-stacked header-dollar-icon${this.state.autofilledBillable ? ' autofill-flash-el' : ''}`}
                  onAnimationEnd={(e) => { if (e.animationName === 'autofill-flash') this.setState({ autofilledBillable: false }); }}
                >
                  <div className='dropdown'>
                    <div
                      className='dropdown-toggle'
                      data-toggle='dropdown'
                      href='#'
                    >
                      <span
                        className={this.state.is_billable === 1 ? 'dollar-inner dollar-inner--on' : 'dollar-inner'}
                        onClick={() => {
                          this.callBillableChange();
                          this.setState({
                            is_billable: this.state.is_billable === 1 ? 0 : 1,
                          });
                        }}
                      >$</span>
                    </div>
                  </div>
                </div>
                <div
                  className='header-top-start-timer-box'
                  style={this.state.isManual ? { display: "none" } : {}}
                >
                  <div className={`time-dur${this.state.displayRunningTimerCalendar ? ' time-dur--editing' : ''}`}>
                    <input
                      type='text'
                      className={`time-duration-field-top${this.state.durationFlash ? ' duration-field--flash' : ''}`}
                      id='enhanced-input-input'
                      onClick={()=>this.callRunningCalendarTImer(hours,minutes,seconds)}
                      onChange={(e) => this.handleDurationChange(e)}
                      onBlur={() => { clearTimeout(this._durationSubmitTimer); this.submitDuration(); }}
                      onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                      onAnimationEnd={() => this.setState({ durationFlash: false })}
                      style={{
                        display:this.state.displayRunningTimerCalendar === false?"none":"block",
                        border:this.state.durationFieldError?"2px solid var(--ti-red)":"",
                      }}
                      value={this.state.displayRunningTimerCalendar === false?
                        `${hours}:${minutes}:${seconds}`
                        :this.state.runningDuration}
                        ref={this.inputRef}
                    />
                    <span className='time-duration-field-top'
                      style={{ fontSize:18,
                      display:this.state.displayRunningTimerCalendar === false?"block":"none"}}
                      onClick={()=>this.callRunningCalendarTImer(hours,minutes,seconds)}
                    >
                    {this.state.displayRunningTimerCalendar === false?
                        `${hours}:${minutes}:${seconds}`
                        :duration}
                    </span>
                    {this.state.displayRunningTimerCalendar && (
                      <div className='duration-presets-popover'>
                        {[
                          { label: '−1h',  delta: -60 },
                          { label: '−30m', delta: -30 },
                          { label: '−15m', delta: -15 },
                          { label: '+15m', delta:  15 },
                          { label: '+30m', delta:  30 },
                          { label: '+1h',  delta:  60 },
                        ].map(({ label, delta }) => (
                          <button
                            key={label}
                            type='button'
                            className='duration-preset-chip'
                            onMouseDown={(e) => { e.preventDefault(); this.adjustDurationByMinutes(delta); }}
                          >
                            {label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className='start-time-btn'>
                    {this.state.isStop === 1 ? (
                      <div style={{ position: 'relative', display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className='play_btn' data-tour='dashboard-create-timer' onClick={this.startTimer}>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='36'
                          height='36'
                          viewBox='0 0 36 36'
                          className='start-play-btn'
                        >
                          <g fill='none' fillRule='evenodd'>
                            <rect
                              width='36'
                              height='36'
                              fill='#8b5cf6'
                              rx='18'
                            ></rect>
                            <path
                              fill='#ffffff'
                              d='M13 11.994c0-1.101.773-1.553 1.745-.997l10.51 6.005c.964.55.972 1.439 0 1.994l-10.51 6.007c-.964.55-1.745.102-1.745-.997V11.994z'
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <span className='kb-hint'>Ctrl+Space</span>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.isStop === 0 ? (
                      <div
                        className='stop_btn'
                        onClick={this.stopTimer}
                        //style={{ display: this.state.hidden ? "none" : "" }}
                        id="stop_btn_id"
                        onMouseEnter={()=>this.callPopOverFunctionEnter()}
                        onMouseLeave={()=>this.callPopOverFunctionLeave()}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='36'
                          height='36'
                          viewBox='0 0 36 36'
                          className='start-pause-btn'
                        >
                          <g fill='none' fillRule='evenodd'>
                            <rect
                              width='36'
                              height='36'
                              fill='#e20505'
                              rx='18'
                            ></rect>
                            <rect
                              width='14'
                              height='14'
                              x='11'
                              y='11'
                              fill='#ffffff'
                              rx='1.5'
                            ></rect>
                          </g>
                        </svg>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div
                  className='header-top-calander-timer-box stop-timer-btn-cont'
                  style={
                    this.state.isManual
                      ? { display: "flex" }
                      : { display: "none" }
                  }
                >
                  <div className='time-dur'>
                    <input
                      type='text'
                      className='time-duration-field-top'
                      id='calander-input'
                      style={{ height: "66px", width:"143px" }}
                      value={this.state.manualStartTime}//{`${this.state.manualStartTime} ${moment(this.state.manualDate).format("MM/DD")}`}
                      onClick={()=>this.setState({displayCalendar : true})}
                      onChange={(e)=>{this.setState({isManuallyChanged:true});this.manualStartTimeChange(e)}}
                      onBlur={this.checkStartTime}
                    />
                  </div>
                  <div className='timer-btween-arrow'>
                    <ArrowButton />
                  </div>
                  <div className='time-dur'>
                    <input
                      type='text'
                      className='time-duration-field-top'
                      id='timer-input'
                      style={{ height: "66px" }}
                      value={this.state.manualEndTime}
                      onChange={(e)=>{this.setState({isManuallyChanged:true});this.manualEndTimeChange(e)}}
                      onBlur={this.checkEndDate}
                    />
                  </div>
                  <div onClick={()=>this.createManualEntry()}
                    onMouseEnter={()=>this.callPopOverFunctionEnter()}
                    onMouseLeave={()=>this.callPopOverFunctionLeave()}
                    id="stop_btn_id"
                  >
                    <ManualPlayButton />
                  </div>
                </div>

                <div className='time-clock-box' 
                  style={{marginLeft:"1%",marginRight:"1%",display:this.state.isStop === 0?"":"none"}}
                  onClick={()=>this.deleteEntry()}
                >
                  <DeleteButton />
                </div>
                <div className='top-header-last-right' style={{display:this.state.isStop === 1?"":"none"}}>
                  <div
                    className='time-clock-box'
                    onClick={() => {
                      this.setState({ isManual: false });
                    }}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='25'
                      height='18'
                      viewBox='0 0 16 16'
                    >
                      <path
                        fill={this.state.isManual ? "#cecece" : "#4AC700"}
                        fillRule='evenodd'
                        d='M7.001 7.948L7 8c0 .556.448 1 1 1h3c.556 0 1-.448 1-1 0-.556-.448-1-1-1H9V3.003a1 1 0 1 0-2 0v4.894l.001.051zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16z'
                      ></path>
                    </svg>
                  </div>
                  <div
                    className='below-time-clock-opt'
                    onClick={() => {
                      this.setState({ isManual: true });
                    }}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='25'
                      height='15'
                      viewBox='0 0 14 12'
                    >
                      <path
                        fill={this.state.isManual ? "#4AC700" : "#cecece"}
                        fillRule='evenodd'
                        d='M0 1c0-.552.45-1 1.007-1h11.986C13.55 0 14 .444 14 1c0 .552-.45 1-1.007 1H1.007A1.001 1.001 0 0 1 0 1zm0 10c0-.552.45-1 1.007-1h11.986c.556 0 1.007.444 1.007 1 0 .552-.45 1-1.007 1H1.007A1.001 1.001 0 0 1 0 11zm0-5c0-.552.45-1 1.007-1h11.986C13.55 5 14 5.444 14 6c0 .552-.45 1-1.007 1H1.007A1.001 1.001 0 0 1 0 6z'
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="datepicker datepicker-dropdown dropdown-menu datepicker-orient-left datepicker-orient-bottom"
          style={{display:this.state.displayCalendar?"block":"none",
          top: "2%", left: "70%", zIndex: "1050",}}
          ref={this.calendarRef}
        >
          <Calendar onChange={item => this.setState({manualDate : item})} 
            weekStartsOn={this.props.auth.user_properties !==null && 
              this.props.auth.user_properties !== undefined ? 
              this.props.auth.user_properties.firstDayOfWeek:0} 
            date={this.state.manualDate}  />
        </div>

        <div className="datepicker datepicker-dropdown dropdown-menu datepicker-orient-left datepicker-orient-bottom" 
          style={{display:this.state.displayRunningTimerCalendar?"block":"none",
                top: "2%", left: "70%", zIndex: "1050"}} 
          ref={this.runningCalendarRef}
        >
          <div style={{display:"flex"}} >
            <div className="time-dur">
              <input type="text" className="time-duration-field-top" id="timer-input" 
              value={this.state.runningTimerStart} 
              onChange={this.changeRunningTimerStart}
              onBlur={()=>this.checkRunningStartTime()}
              style={{width:"91%",marginLeft:"6%",marginRight:"3%"}}/>
            </div>
            <div className="time-dur">
              <input type="text" className="time-duration-field-top" id="timer-input" 
                value={this.state.runningTimerStop} 
                //onChange={this.changeRunningTimerStop}
                readOnly={true}
              style={{width:"91%",marginRight:"6%",marginLeft:"3%"}}/>
            </div>
          </div>
          <Calendar maxDate={new Date()} onChange={item => this.changeDateInCalendar(item)} 
          //onChange={date => {
            //this.changeDateInCalendar(moment(`${moment(date).format('YYYY-MM-DDThh:mm:ss')}${moment().tz(this.state.timezone).utcOffset()/60}`));
            // This is to get the offset from a timezone: handleChange(moment(`${moment(date).format('YYYY-MM-DDThh:mm:ss')}${moment.tz('US/Pacific').format('Z')}`));
          //}}
            weekStartsOn={this.props.auth.user_properties !==null && 
              this.props.auth.user_properties !== undefined ? 
              this.props.auth.user_properties.firstDayOfWeek:0}   
            //item => this.setState({manualDate : item})}
            date={this.state.manualDate}  />
        </div>

        <div className='content-wrap dashboard-bg mz-sidebar-offset' id='wrapper'>
          <div className='main'>

            {/* ── Dashboard Page Header ── */}
            <div className='dash-page-header'>
              <div className='dash-page-title'>
                <h1>{tr("Dashboard")}</h1>
                <p>{tr("Track your time and manage your projects with ease")}</p>
              </div>
              <div className='dash-header-actions'>
                <a href='/reports' className='btn-dash-secondary'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 16" fill="currentColor">
                    <path fillRule="evenodd" d="M0 1.994A2 2 0 012.006 0h9.988C13.102 0 14 .895 14 1.994v12.012A2 2 0 0111.994 16H2.006A2.001 2.001 0 010 14.006V1.994zM2 3c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C2.455 2 2 2.448 2 3zm0 3c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C2.455 5 2 5.448 2 6zm0 3c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C2.455 8 2 8.448 2 9z"/>
                  </svg>{tr("View Reports")} </a>
                <a href='/projects' className='btn-dash-primary'>{tr("+ New Project")} </a>
              </div>
            </div>

            {/* ── Attendance Check-In Bar ── */}
            <CheckInWidget />

            {/* ── Suggestions + Heatmap ── */}
            {!this.state.loading && (() => {
              const suggestions = this.state.suggestions || [];
              const hasSuggestionsPanel = this.state.suggestionsLoading || suggestions.length > 0;
              const activeSuggestion = suggestions.length > 0
                ? suggestions[Math.min(this.state.suggestionCursor, suggestions.length - 1)]
                : null;

              return (
                <div className={`dash-insights-row${hasSuggestionsPanel ? '' : ' dash-insights-row--single'}`}>
                  {hasSuggestionsPanel && (
                    <div className={`ts-window dash-insights-card dash-insights-card--suggestions${activeSuggestion ? ' ts-window--visible' : ' ts-window--empty'}`}>
                      <div className='ts-section-header'>
                        <div>
                          <span className='ts-section-label'>{tr("Suggested time entries")}</span>
                          <p className='ts-section-subtitle'>{tr("Privacy-safe suggestions from verified desktop activity. Nothing is logged until you approve it.")} </p>
                        </div>
                        <span className='ts-window-badge'>
                          {this.state.suggestionsLoading
                            ? tr("Loading...")
                            : `${this.state.suggestions.length} available`}
                        </span>
                      </div>
                      {!this.state.suggestionsLoading && this.state.suggestions.length > 0 && (
                        <div className='ts-carousel-bar'>
                          <div className='ts-carousel-count'>
                            {this.state.suggestionCursor + 1} / {this.state.suggestions.length}
                          </div>
                          <div className='ts-carousel-actions'>
                            <button
                              type='button'
                              className='ts-nav-btn'
                              onClick={this.goToPreviousSuggestion}
                              disabled={this.state.suggestions.length <= 1}
                            >{tr("Previous")} </button>
                            <button
                              type='button'
                              className='ts-nav-btn'
                              onClick={this.goToNextSuggestion}
                              disabled={this.state.suggestions.length <= 1}
                            >{tr("Next")} </button>
                          </div>
                        </div>
                      )}
                      {this.state.suggestionMessage && (
                        <div
                          className={`ts-inline-message ts-inline-message--${this.state.suggestionMessageType || 'success'}`}
                          role='status'
                          aria-live='polite'
                        >
                          {this.state.suggestionMessage}
                        </div>
                      )}
                      {this.state.timerSyncMessage && (
                        <div
                          className={`ts-inline-message ts-inline-message--${this.state.timerSyncMessageType || 'success'}`}
                          role='status'
                          aria-live='polite'
                        >
                          {tr(this.state.timerSyncMessage)}
                        </div>
                      )}
                      {this.state.suggestionsLoading ? null : activeSuggestion ? (() => {
                        const suggestion = activeSuggestion;
                        const topApps = (suggestion.top_apps || []).map((item) => item.app_name).filter(Boolean);
                        const topDomains = (suggestion.top_domains || []).map((item) => item.domain).filter(Boolean);
                        const isBusy = this.state.suggestionActionId === suggestion.id;
                        const isDemoSuggestion = suggestion?.source_summary?.type === 'demo';
                        return (
                          <div className='ts-carousel-stage'>
                            <div className={`ts-card ts-card--single${isDemoSuggestion ? ' ts-card--demo' : ''}`} key={suggestion.id}>
                              <div className='ts-card-top'>
                                <div>
                                  <span className='ts-card-kicker'>{this.formatSuggestionWindow(suggestion.suggested_start, suggestion.suggested_end)}</span>
                                  <div className='ts-card-title-row'>
                                    <h3 className='ts-card-title'>{suggestion.suggested_title || tr("Suggested work session")}</h3>
                                    {isDemoSuggestion && (
                                      <span className='ts-card-source-pill'>{tr("Demo")}</span>
                                    )}
                                  </div>
                                </div>
                                <span className='ts-card-duration'>{suggestion.display_duration}</span>
                              </div>
                              {isDemoSuggestion && (
                                <p className='ts-card-source-note'>{tr("Auto-generated test suggestion. Use this card to try")} <strong>{tr("Log time")}</strong>.
                                </p>
                              )}
                              <p className='ts-card-message'>{suggestion.suggested_message}</p>
                              <div className='ts-card-meta'>
                                {suggestion.suggested_project_name && (
                                  <span className='ts-meta-pill ts-meta-pill--project'>{suggestion.suggested_project_name}</span>
                                )}
                                {topApps.slice(0, 2).map((app) => (
                                  <span className='ts-meta-pill' key={app}>{app}</span>
                                ))}
                                {topDomains.slice(0, 2).map((domain) => (
                                  <span className='ts-meta-pill ts-meta-pill--domain' key={domain}>{domain}</span>
                                ))}
                              </div>
                              {suggestion.confidence_explanation && (
                                <p className='ts-card-confidence'>{suggestion.confidence_explanation}</p>
                              )}
                              <div className='ts-card-actions'>
                                <button
                                  type='button'
                                  className='ts-btn ts-btn--primary'
                                  onClick={() => this.acceptSuggestion(suggestion)}
                                  disabled={isBusy}
                                >
                                  {isBusy ? 'Logging...' : tr("Log time")}
                                </button>
                                <button
                                  type='button'
                                  className='ts-btn ts-btn--ghost'
                                  onClick={() => this.dismissSuggestion(suggestion.id)}
                                  disabled={isBusy}
                                >{tr("Dismiss")} </button>
                              </div>
                            </div>
                          </div>
                        );
                      })() : (
                        <div className='ts-empty-window'>
                          <p className='ts-empty-window__title'>{tr("No suggestions available right now")}</p>
                          <p className='ts-empty-window__sub'>{tr("When desktop activity is detected, suggested time entries will appear here for review.")}</p>
                        </div>
                      )}
                    </div>
                  )}

                  <div className='dash-insights-card dash-insights-card--heat'>
                    <HeatWidget
                      entries={this.state.heatmapEntries}
                      timezone={this.state.timezone}
                      onDateSelect={this.selectRecentEntriesDate}
                      selectedDateKey={this.state.selectedRecentDateKey}
                      windowMonths={hasSuggestionsPanel ? 3 : 6}
                    />
                  </div>
                </div>
              );
            })()}

            {/* ── Quick Continue: Recent Entries ── */}
            {!this.state.loading && this.state.timeList2 && this.state.timeList2.length > 0 && (() => {
              const seen = new Set();
              const recent = [];
              const activeTimerId = this.state.isStop === 0 ? String(this.state.timer_id) : null;
              for (const entry of this.state.timeList2) {
                if (activeTimerId && String(entry.timer_id) === activeTimerId) {
                  continue;
                }
                const key = `${entry.title}__${entry.project_id || ''}`;
                if (!seen.has(key)) {
                  seen.add(key);
                  recent.push(entry);
                }
                if (recent.length === 4) break;
              }
              return (
                <div className='re-section'>
                  <div className='re-section-header'>
                    <span className='re-section-icon' aria-hidden='true'>
                      <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                        <polyline points='1 4 1 10 7 10'/>
                        <path d='M3.51 15a9 9 0 1 0 .49-3.51'/>
                      </svg>
                    </span>
                    <span className='re-section-label'>{tr("Quick Continue")}</span>
                  </div>
                  <div className='re-cards-grid'>
                    {recent.map((entry, i) => {
                      const projectName = entry.project_name || entry.project;
                      const color = entry.project_color || '#9ca3af';
                      const isSuggestedEntry =
                        entry.entry_origin === 'AI_SUGGESTED' ||
                        /^Suggested work session/i.test(entry.title || '');
                      return (
                        <div className={`re-card${isSuggestedEntry ? ' re-card--suggested' : ''}`} key={i} style={{ '--re-accent': color }}>
                          <div className='re-card-dot' aria-hidden='true' />
                          <div className='re-card-body'>
                            <div className='re-card-title-row'>
                              <span className='re-card-title'>{entry.title || '(no description)'}</span>
                              {isSuggestedEntry && <span className='re-card-source-pill'>{tr("AI")}</span>}
                            </div>
                            <span className='re-card-meta'>
                              {projectName ? (
                                <span className='re-card-project'>{projectName}</span>
                              ) : (
                                <span className='re-card-project re-card-project--empty'>
                                  <svg xmlns='http://www.w3.org/2000/svg' width='13' height='10' viewBox='0 0 16 13' aria-hidden='true'>
                                    <path
                                      fill='currentColor'
                                      fillRule='evenodd'
                                      d='M0 6h16v4.994A2.001 2.001 0 0 1 14.006 13H1.994A1.993 1.993 0 0 1 0 10.994V6zm0-4a2 2 0 0 1 2.004-2h3.05c1.107 0 2.004.895 2.004 2h6.935C15.102 2 16 2.895 16 4H0V2z'
                                    />
                                  </svg>
                                  <span>{tr("No Project")}</span>
                                </span>
                              )}
                              {entry.displayTime && <span className='re-card-duration'>{entry.displayTime}</span>}
                            </span>
                          </div>
                          <div className='re-card-actions'>
                            <button
                              className='re-card-btn re-card-btn--edit'
                              title={tr("Prefill timer without starting")}
                              onClick={() => this.prefillTimer(entry)}
                            >
                              <svg xmlns='http://www.w3.org/2000/svg' width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                                <path d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7'/>
                                <path d='M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z'/>
                              </svg>
                            </button>
                            <button
                              className='re-card-btn re-card-btn--start'
                              title={tr("Start timer now")}
                              onClick={() => this.secondTimer(entry)}
                            >
                              <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10' fill='currentColor'>
                                <path d='M2 1.5v7l6-3.5L2 1.5z'/>
                              </svg>{tr("Start")} </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            {/* ── Stats Grid + Middle Row (skeleton while loading) ── */}
            {this.state.loading ? <DashboardSkeleton /> : null}

            {/* ── Stats Grid ── */}
            {this.state.loading ? null : (() => {
              const stats = this.getDashboardStats();
              const todayStr = this.formatDuration(stats.todayMs);
              const weekStr  = this.formatDuration(stats.weekMs);
              return (
                <div className='dash-stats-grid'>

                  {/* Today's Time + Daily Goal */}
                  {(() => {
                    const goalMs  = this.state.dailyGoalHours * 3600000;
                    const pct     = Math.min(100, Math.round((stats.todayMs / goalMs) * 100));
                    const reached = pct >= 100;
                    const animVariant = reached
                      ? ['goal--anim-a', 'goal--anim-b', 'goal--anim-c'][new Date().getDay() % 3]
                      : '';
                    return (
                      <div className={`dash-stat-card dash-stat-card--dark${reached ? ' goal--reached' : ''} ${animVariant}`}>
                        <a href='/reports' className='dash-stat-arrow'>↗</a>
                        <p className='dash-stat-label'>{tr("Today's Time")}</p>
                        <h2 className='dash-stat-value'>{todayStr}</h2>
                        {/* Goal progress bar */}
                        <div className='daily-goal-bar-wrap'>
                          <div className='daily-goal-bar-track'>
                            <div
                              className={`daily-goal-bar-fill${reached ? ' daily-goal-bar-fill--done' : ''}`}
                              style={{ width: `${pct}%` }}
                            />
                          </div>
                          <div className='daily-goal-label'>
                            {this.state.dailyGoalEditing ? (
                              <span className='daily-goal-edit-row'>
                                <input
                                  type='number'
                                  min='0.5'
                                  max='24'
                                  step='0.5'
                                  className='daily-goal-input'
                                  value={this.state.dailyGoalInput}
                                  onChange={e => this.setState({ dailyGoalInput: e.target.value })}
                                  onBlur={this.saveDailyGoal}
                                  onKeyDown={e => e.key === 'Enter' && this.saveDailyGoal()}
                                  autoFocus
                                />
                                <span>{tr("h goal")}</span>
                              </span>
                            ) : (
                              <span
                                className='daily-goal-text'
                                onClick={() => this.setState({ dailyGoalEditing: true })}
                                title={tr("Click to change daily goal")}
                              >
                                {reached ? '🎯 ' : ''}{pct}{tr("% of")} {this.state.dailyGoalHours}{tr("h goal")} <span className='daily-goal-edit-icon'>✎</span>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })()}

                  {/* This Week */}
                  <div className='dash-stat-card'>
                    <a href='/reports' className='dash-stat-arrow'>↗</a>
                    <p className='dash-stat-label'>{tr("This Week")}</p>
                    <h2 className='dash-stat-value'>{weekStr}</h2>
                    <p className='dash-stat-trend--neutral'>{tr("Weekly total")}</p>
                  </div>

                  {/* Active Projects */}
                  <div className='dash-stat-card'>
                    <a href='/projects' className='dash-stat-arrow'>↗</a>
                    <p className='dash-stat-label'>{tr("Active Projects")}</p>
                    <h2 className='dash-stat-value'>{stats.projectCount}</h2>
                    <p className='dash-stat-trend--neutral'>{tr("Projects this week")}</p>
                  </div>

                  {/* Running Timer */}
                  <div className={`dash-stat-card dash-stat-card--timer${this.state.isStop === 0 ? ' dash-stat-card--timer--active' : ''}`}>
                    <i className='timer-scan-line' aria-hidden='true'></i>
                    <p className='dash-stat-label'>{tr("Time Tracker")}</p>
                    <h2 className='dash-stat-value'>{hours}:{minutes}:{seconds}</h2>
                    <div className='dash-timer-controls'>
                      <div className='dash-timer-pill'>
                        <span className={this.state.isStop === 0 ? 'dot' : 'dot dot--idle'}></span>
                        {this.state.isStop === 0 ? tr("Active session") : tr("No active timer")}
                      </div>
                    </div>
                  </div>

                </div>
              );
            })()}

            {/* ── Middle Row: Chart + Projects Panel ── */}
            <div className='dash-middle-row' style={{ display: this.state.loading ? 'none' : '' }}>

              {/* Time Analytics Chart */}
              <div className='dash-card'>
                <div className='dash-card-header'>
                  <div>
                    <h3 className='dash-card-title'>{tr("Time Analytics")}</h3>
                    <p className='dash-card-subtitle'>{tr("Hours tracked per day — last 7 days")}</p>
                  </div>
                  <a href='/reports' className='btn-dash-link'>{tr("View Reports →")}</a>
                </div>
                <div className='dash-card-body dash-chart-body'>
                  {(() => {
                    const { labels, data } = this.getWeeklyChartData();
                    if (data.every(v => v === 0)) {
                      return (
                        <div className='dash-chart-empty'>
                          <svg width='32' height='32' viewBox='0 0 24 24' fill='none'>
                            <path d='M3 18h3v-6H3v6zm4 0h3V8H7v10zm4 0h3v-4h-3v4zm4 0h3V4h-3v14z' fill='#d1d5db'/>
                          </svg>
                          <p>{tr("No data for this period")}</p>
                        </div>
                      );
                    }
                    const maxVal = Math.max(...data, 1);
                    const chartData = {
                      labels,
                      datasets: [{
                        label: 'Hours',
                        backgroundColor: data.map((v, i) =>
                          i === data.length - 1 ? '#2a1642' :
                          v === maxVal          ? '#4b2a73' : '#ddd2f5'
                        ),
                        borderRadius: 8,
                        data,
                      }],
                    };
                    return (
                      <Bar data={chartData} options={{
                        maintainAspectRatio: false,
                        plugins: {
                          legend: { display: false },
                          tooltip: { callbacks: { label: (ctx) => ` ${ctx.parsed.y}h` } },
                        },
                        scales: {
                          y: { beginAtZero: true, ticks: { color: '#6b7280', font: { size: 11 } }, grid: { color: '#f0f2f0', drawBorder: false } },
                          x: { ticks: { color: '#6b7280', font: { size: 12, weight: 'bold' } }, grid: { display: false } },
                        },
                      }} />
                    );
                  })()}
                </div>
              </div>

              {/* Projects Quick List */}
              <div className='dash-card'>
                <div className='dash-card-header'>
                  <div>
                    <h3 className='dash-card-title'>{tr("Projects")}</h3>
                    <p className='dash-card-subtitle'>{tr("Active this week")}</p>
                  </div>
                  <a href='/projects' className='btn-dash-new'>{tr("+ New")}</a>
                </div>
                <div className='dash-card-body'>
                  {(() => {
                    const flat = [];
                    Object.values(this.state.projectArray).forEach(group => {
                      group.forEach(p => { if (p.id !== 0) flat.push(p); });
                    });
                    if (flat.length === 0) {
                      return (
                        <div className='dash-empty-state'>
                          <p>{tr("No projects yet.")}</p>
                          <a href='/projects' className='btn-dash-primary' style={{fontSize:'13px',padding:'8px 16px'}}>{tr("Create your first project")}</a>
                        </div>
                      );
                    }
                    return flat.slice(0, 7).map((proj, i) => (
                      <div className='dash-project-item' key={proj.id || i}>
                        <div className='dash-project-dot' style={{background: proj.project_color || '#ccc'}}></div>
                        <div className='dash-project-info'>
                          <div className='dash-project-name'>{proj.project_name}</div>
                          <div className='dash-project-client'>
                            {proj.client_name && proj.client_name !== 'null' ? proj.client_name : tr("No client")}
                          </div>
                        </div>
                        {proj.isbillable === 1 &&
                          <span className='dash-billable-badge'>{tr("Billable")}</span>
                        }
                      </div>
                    ));
                  })()}
                </div>
              </div>

            </div>{/* end dash-middle-row */}

            {/* ── Project Statistics Chart ── */}
            <ProjectChart token={this.props.auth.token} workspace_id={this.props.auth.workspace_id} />

            {/* ── Onboarding Checklist ── */}
            {!this.state.loading && (
              <OnboardingChecklist
                token={this.props.auth.token}
                workspace_id={this.props.auth.workspace_id}
                hasTimers={this.state.timeList2.length > 0}
              />
            )}

            {/* ── Recent Entries Section ── */}
            <div className='dash-entries-section' ref={this.recentEntriesRef}>
              {(() => {
                const activeRecentList = this.state.selectedRecentDateKey
                  ? (this.state.selectedRecentDateList || {})
                  : this.state.timeList;
                const activeRecentCount = this.getVisibleRecentEntryCount(activeRecentList);
                const selectedRecentDateLabel = this.state.selectedRecentDateKey
                  ? moment(this.state.selectedRecentDateKey, 'YYYY-MM-DD').toDate().toLocaleDateString(getLocale(), { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })
                  : '';

                return (
                  <>
              <div className='dash-section-header'>
                <h3 className='dash-section-title'>
                  {this.state.selectedRecentDateKey ? `Entries for ${selectedRecentDateLabel}` : tr("Recent Time Entries")}
                  {activeRecentCount > 0 &&
                    <span className='dash-section-badge'>{activeRecentCount}</span>
                  }
                </h3>
                {this.state.selectedRecentDateKey && (
                  <button
                    type='button'
                    className='dash-section-clear'
                    onClick={this.clearRecentEntriesDateFilter}
                  >{tr("Clear filter")} </button>
                )}
              </div>

            {this.state.loading || (this.state.selectedRecentDateKey && this.state.selectedRecentDateList === null) ? (
              <TimerListSkeleton />
            ) : Object.keys(activeRecentList || {}).length === 0 ? (
              <div className='dash-empty-timelist'>
                <svg width='40' height='40' viewBox='0 0 24 24' fill='none'>
                  <circle cx='12' cy='12' r='9' stroke='#d1d5db' strokeWidth='1.5'/>
                  <path d='M12 7v5l3 3' stroke='#d1d5db' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
                <p className='dash-empty-timelist__title'>
                  {this.state.selectedRecentDateKey ? tr("No entries for this date") : tr("No time entries yet")}
                </p>
                <p className='dash-empty-timelist__sub'>
                  {this.state.selectedRecentDateKey
                    ? tr("Try another day in the heatmap or clear the filter to return to the full recent list.")
                    : tr("Start the timer or add a manual entry to track your time in this workspace.")}
                </p>
                {this.state.selectedRecentDateKey ? (
                  <button
                    className='dash-empty-timelist__cta'
                    onClick={this.clearRecentEntriesDateFilter}
                  >{tr("Show all recent entries")} </button>
                ) : (
                  <button
                    className='dash-empty-timelist__cta'
                    onClick={() => this.inputRef.current && this.inputRef.current.focus()}
                  >{tr("↑ Start your first timer")} </button>
                )}
              </div>
            ) : (
              <Suspense fallback={<TimerListSkeleton />}>
                <TimerList
                  callBack={this.secondTimer}
                  list={activeRecentList}
                  titleChange={this.changeTitle}
                  billableChange={this.changeBillable}
                  callTagChange={this.changeTag}
                  callProjectChange={this.changeProject}
                  reloadDashBoard={this.reload}
                  deleteEntry={this.deleteRecentEntryOptimistically}
                  group_similar={this.state.is_group_similar}
                />
              </Suspense>
            )}
            <Overlay
              show={this.state.showPopOver}
              target={this.state.popOverTarget}
              placement={"bottom"}
              //container={ref.current}
              containerPadding={20}
            >
              <Popover id="popover-contained">
                <Popover.Header><strong>{tr("Add Description and Project")} </strong></Popover.Header>
                <Popover.Body>{tr("Fill out the required fields to stop the timer.")} </Popover.Body>
              </Popover>
            </Overlay>
            <ProjectModal 
              show={this.state.projectModalShow}
              title={this.state.searchTerm}
              handleClose={this.hideModal}
              reloadList={this.reloadFunction}
              //setProjectInDashBoard={this.setProject}
            />

              <div className="in-timer_load-moreBtn-wra" style={{
                display: this.state.loading === true || this.state.spinner === true || Object.keys(this.state.timeList).length === 0 || this.state.selectedRecentDateKey ? "none" : "",
                marginBottom : "32px"
              }}>
              <button className="load-more" onClick={()=>{this.loadMoreItems();
                  this.setState({ spinner : true})}} 
              >{tr("Load more")}</button>
            </div>
            
            <div className="in-timer_load-moreBtn-wra" style={{marginBottom : "32px",
              display : this.state.spinner?"":"none"}}>
              <Spinner animation="border" role="status" size="lg" />
            </div>

                  </>
                );
              })()}
            </div>{/* end dash-entries-section */}

            <section id='main-content'>
              <div className='row'></div>
            </section>

          </div>
          <Footer />
        </div>

        {/* ── Check-In Enforcement Modal ───────────────────────── */}
        {this.state.checkinPromptShow && (
          <div className='idle-modal-backdrop'>
            <div className='idle-modal'>
              <div className='idle-modal-icon'>🕐</div>
              <h3 className='idle-modal-title'>{tr("You're not checked in")}</h3>
              <p className='idle-modal-body'>{tr("Your workspace requires check-in before tracking time.")}<br />{tr("Would you like to check in now?")} </p>
              <div className='idle-modal-actions'>
                <button
                  className='idle-btn idle-btn--discard'
                  onClick={this.handleSkipCheckin}
                  disabled={this.state.checkinPromptLoading}
                >{tr("Skip")} </button>
                <button
                  className='idle-btn idle-btn--keep'
                  onClick={this.handleCheckinAndStart}
                  disabled={this.state.checkinPromptLoading}
                >
                  {this.state.checkinPromptLoading ? tr("Checking in…") : tr("Check in & start timer")}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Idle Detection Modal ──────────────────────────────── */}
        {this.state.idleModalShow && (
          <div className='idle-modal-backdrop'>
            <div className='idle-modal'>
              <div className='idle-modal-icon'>⏸</div>
              <h3 className='idle-modal-title'>{tr("You've been idle")}</h3>
              <p className='idle-modal-body'>{tr("No activity detected for")} <strong>{this.state.idleMinutes} {tr("minute")}{this.state.idleMinutes !== 1 ? 's' : ''}</strong>.
                <br />{tr("What would you like to do with that time?")} </p>
              <div className='idle-modal-actions'>
                <button className='idle-btn idle-btn--discard' onClick={this.discardIdleTime}>{tr("Remove idle time")} </button>
                <button className='idle-btn idle-btn--keep' onClick={this.keepIdleTime}>{tr("Keep it")} </button>
              </div>
              <p className='idle-modal-hint'>{tr("Timer started at")} {this.state.timer_start ? new Date(this.state.timer_start * 1000).toLocaleTimeString(getLocale(), {hour:'2-digit',minute:'2-digit'}) : ''}</p>
            </div>
          </div>
        )}

        <ScrollToTopButton />

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  invite_ids : state.invite_ids
});

export default connect(mapStateToProps)(Home);
